/* Bridgewater Direct: phone cut-list app for the cut-to-size panel builders (<=767px only).
   Pairs with bd-cutlist-mobile.css. The builder exposes pb.pbCutlist; every panel this app adds,
   edits, duplicates or imports is written into the builder's own table rows, so the desktop
   engine does all validation, sheet counting, pricing and the add-to-basket call. Nothing here
   calculates a price. Tablet and desktop never see this app (the builder runs as before). */
(function () {
  'use strict';

  var PHONE = '(max-width: 767px)';
  var EDGE_SIDES = { '0': '', '1': 't', '2': 'tb', '3': 'l', '6': 'lr', '7': 'tlr', '5': 'tbl', '4': 'tblr' };
  // Edging is one choice per panel, shown as cards: the four most used first, the rest behind
  // "More edge combinations". The codes are the builder's own (its .pb-e select values).
  var EDGE_MAIN = ['4', '2', '1', '0'];
  var EDGE_MORE = ['6', '3', '5', '7'];
  // Card names say Length/Width, as the size fields do ("long" in the builders' own names means the
  // Length side even when it is the shorter one). The basket keeps the builder's names.
  var EDGE_TITLE = {
    '4': 'All edges', '2': 'Length edges only', '1': 'One length edge', '6': 'Width edges only',
    '3': 'One width edge', '5': '2 lengths + 1 width', '7': '1 length + 2 widths'
  };
  var ICON_COPY = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/></svg>';
  var ICON_EDIT = '<svg class="clm-card__pen" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16v4zM14 6l4 4"/></svg>';
  var ICON_BIN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>';
  var ICON_PEN = '<svg class="clm-colourchip__pen" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16v4zM14 6l4 4"/></svg>';
  var CAP = 15; // colours shown before "Show all"

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Replace an element's markup only when it changed. Rebuilding identical markup swaps the node a
  // finger is on mid-tap, and the browser then fires no click at all (the first tap is lost).
  function setHtml(el, html) {
    if (el.__clmHtml === html && el.firstChild) return false;
    el.innerHTML = html;
    el.__clmHtml = html;
    return true;
  }
  function money(pence) {
    return '£' + (Math.round(Number(pence || 0)) / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function titleCase(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function int(v) { var n = parseInt(String(v == null ? '' : v).replace(/[^\d]/g, ''), 10); return isFinite(n) ? n : 0; }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : (many || one + 's')); }
  // How many Length sides (top, bottom) and Width sides (left, right) an edging code covers.
  function edgeCounts(code) {
    var s = EDGE_SIDES[code] || '';
    return {
      nL: (s.indexOf('t') >= 0 ? 1 : 0) + (s.indexOf('b') >= 0 ? 1 : 0),
      nW: (s.indexOf('l') >= 0 ? 1 : 0) + (s.indexOf('r') >= 0 ? 1 : 0)
    };
  }
  function metresText(m) { return (Math.round(Number(m || 0) * 100) / 100).toLocaleString('en-GB', { maximumFractionDigits: 2 }) + ' m'; }
  function ago(t) {
    var m = Math.round((Date.now() - t) / 60000);
    if (m < 2) return 'just now';
    if (m < 60) return m + ' minutes ago';
    var h = Math.round(m / 60);
    if (h < 24) return plural(h, 'hour') + ' ago';
    return plural(Math.round(h / 24), 'day') + ' ago';
  }

  // Panel outline to scale (Length left to right) in a 64 x 44 box; 2:1 until both sizes are known.
  function figBox(l, w) {
    var VW = 64, VH = 44, pad = 4;
    if (!(l > 0) || !(w > 0)) { l = 2; w = 1; }
    var s = Math.min((VW - pad * 2) / l, (VH - pad * 2) / w);
    var rw = Math.max(6, l * s), rh = Math.max(6, w * s);
    var r = function (n) { return Math.round(n * 10) / 10; };
    return { x: r((VW - rw) / 2), y: r((VH - rh) / 2), w: r(rw), h: r(rh) };
  }
  function sideXY(k, b) {
    return {
      x1: k === 'r' ? b.x + b.w : b.x, y1: k === 'b' ? b.y + b.h : b.y,
      x2: k === 'l' ? b.x : b.x + b.w, y2: k === 't' ? b.y : b.y + b.h
    };
  }
  // Small panel drawing: edged sides a thick navy line, the others the thin grey outline. The same
  // drawing marks the edging on the option cards, the panel cards and the review.
  function edgeSvg(l, w, code, cls) {
    var b = figBox(l, w);
    var lines = (EDGE_SIDES[code] || '').split('').map(function (k) {
      var p = sideXY(k, b);
      return '<line data-s="' + k + '" x1="' + p.x1 + '" y1="' + p.y1 + '" x2="' + p.x2 + '" y2="' + p.y2 + '"/>';
    }).join('');
    return '<svg class="clm-efig ' + cls + '" viewBox="0 0 64 44" aria-hidden="true" focusable="false">' +
      '<rect x="' + b.x + '" y="' + b.y + '" width="' + b.w + '" height="' + b.h + '"/>' + lines + '</svg>';
  }
  function panelFig(l, w, code, cls) {
    if (!(l > 0) || !(w > 0)) return '<span class="' + cls + '" aria-hidden="true"></span>';
    return edgeSvg(l, w, code, cls);
  }
  // New sizes for a drawing already on screen, changed in place: a node replaced under a finger
  // loses that tap.
  function reshapeSvg(svg, l, w) {
    var b = figBox(l, w);
    var set = function (el, a) {
      Object.keys(a).forEach(function (k) { var v = String(a[k]); if (el.getAttribute(k) !== v) el.setAttribute(k, v); });
    };
    set(svg.querySelector('rect'), { x: b.x, y: b.y, width: b.w, height: b.h });
    svg.querySelectorAll('line').forEach(function (ln) { set(ln, sideXY(ln.getAttribute('data-s'), b)); });
  }

  function mount(pb, api) {
    var root = pb.querySelector('[data-clm]');
    if (!root || !api || root.dataset.clmMounted) return;
    root.dataset.clmMounted = '1';
    function noun(form) {
      var wds = api.words;
      if (form === 'one') return (wds && wds.one) || 'panel';
      if (form === 'many') return (wds && wds.many) || 'panels';
      if (form === 'One') return (wds && wds.One) || 'Panel';
      if (form === 'Many') return (wds && wds.Many) || ((wds && wds.One) ? wds.One + 's' : 'Panels');
      return 'panel';
    }
    var dimL = (api.dimLabels && api.dimLabels.l) || 'Length';
    var dimW = (api.dimLabels && api.dimLabels.w) || 'Width';
    var phL = (api.dimLabels && api.dimLabels.phL) || 'e.g. 600';
    var phW = (api.dimLabels && api.dimLabels.phW) || 'e.g. 300';
    function moneyShown(pence) {
      if (!api.vat || !api.vat.rate) return money(pence) + ' <small>exc VAT</small>';
      var net = Math.round(Number(pence || 0));
      var gross = Math.round(net * Number(api.vat.rate));
      return money(gross) + ' <small>' + (api.vat.label || 'inc VAT') + '</small><span class="clm-ex">' + money(net) + ' ' + (api.vat.exLabel || 'exc VAT') + '</span>';
    }
    function rowFieldsHtml(e) {
      if (!api.rowFields || !api.rowFields.length) return '';
      return api.rowFields.map(function (f) {
        var val = e[f.key] == null ? '' : String(e[f.key]);
        var disabled = false;
        if (f.disabledWhen) {
          Object.keys(f.disabledWhen).forEach(function (k) {
            if (String(e[k] == null ? '' : e[k]) === String(f.disabledWhen[k])) disabled = true;
          });
        }
        if (disabled) {
          return '<label class="clm-field clm-field--select"><span>' + esc(f.label) + '</span><select data-f="' + esc(f.key) + '" disabled><option value="">—</option></select></label>';
        }
        var opts = (f.options || []).map(function (o) {
          var ov = String(o.value);
          return '<option value="' + esc(ov) + '"' + (ov === val ? ' selected' : '') + '>' + esc(o.label) + '</option>';
        }).join('');
        return '<label class="clm-field clm-field--select"><span>' + esc(f.label) + '</span><select data-f="' + esc(f.key) + '">' + opts + '</select></label>';
      }).join('');
    }
    function syncRowFields(form, e) {
      if (!api.rowFields || !form) return;
      api.rowFields.forEach(function (f) {
        var sel = form.querySelector('[data-f="' + f.key + '"]');
        if (!sel || !f.disabledWhen) return;
        var off = false;
        Object.keys(f.disabledWhen).forEach(function (k) {
          if (String(e[k] == null ? '' : e[k]) === String(f.disabledWhen[k])) off = true;
        });
        if (off) {
          if (!sel.querySelector('option[value=""]')) {
            var o = document.createElement('option');
            o.value = '';
            o.textContent = '—';
            sel.insertBefore(o, sel.firstChild);
          }
          sel.disabled = true;
          sel.value = '';
        } else if (sel.disabled) {
          sel.disabled = false;
          var blank = sel.querySelector('option[value=""]');
          if (blank && (f.options || []).length) blank.remove();
          if ((f.options || []).length && sel.options.length < f.options.length) {
            sel.innerHTML = f.options.map(function (o) {
              return '<option value="' + esc(String(o.value)) + '">' + esc(o.label) + '</option>';
            }).join('');
          }
          if (e[f.key]) sel.value = String(e[f.key]);
        }
      });
    }

    var cfg = {};
    try { cfg = JSON.parse(pb.querySelector('[data-clm-config]').textContent || '{}'); } catch (e) { cfg = {}; }
    var STORE_KEY = 'bd-clm-draft-' + (api.product || 'panels');
    var mq = window.matchMedia(PHONE);

    // returnTo: 'review' while the colour step was opened from the review step, so a new colour goes back there.
    var S = {
      view: 'list', gid: null, edit: null, filter: 'all', q: '', showAll: false,
      report: null, pendingImport: null, undo: null, toast: '', busy: false, depth: 0,
      returnTo: null, flashGid: null,
      edgeMore: false, draft: readDraft()
    };
    var toastTimer = 0;
    var seq = 0;
    var qtyId = 'clm-q-' + Math.random().toString(36).slice(2, 8);

    // ---------- builder state helpers ----------
    function groups() { return api.groups; }
    function group(gid) { return api.groups.find(function (g) { return g.id === gid; }) || null; }
    function gIndex(gid) { return api.groups.findIndex(function (g) { return g.id === gid; }); }
    function activeGroup() {
      var g = group(S.gid);
      if (!g) { g = api.groups[0] || null; S.gid = g ? g.id : null; }
      return g;
    }
    function rowId(tr) { if (!tr.dataset.clmId) tr.dataset.clmId = 'p' + (++seq); return tr.dataset.clmId; }
    function isBlank(tr) {
      var nameEl = tr.querySelector('.pb-name');
      var name = nameEl ? nameEl.value.trim() : '';
      return !tr.querySelector('.pb-l').value && !tr.querySelector('.pb-w').value && !name;
    }
    function panelsOf(gid) {
      return api.rowsFor(gid).filter(function (tr) { return !isBlank(tr); }).map(function (tr) {
        var d = api.rowData(tr);
        var nameEl = tr.querySelector('.pb-name');
        return { tr: tr, id: rowId(tr), name: d.name, ownName: nameEl ? nameEl.value.trim() : '', l: d.l, w: d.w, q: d.q, e: d.e, r: d.r, c: d.c, err: api.checkPanel(gid, d.l, d.w, d), warn: tr.dataset.clmWarn || '' };
      });
    }
    function findRow(gid, id) {
      return api.rowsFor(gid).find(function (tr) { return tr.dataset.clmId === id; }) || null;
    }
    // An edging option's name as its card shows it ("No edging" / "No machining" is the builder's own).
    function edgeLabel(code) {
      if (!api.edgeLabels) return '';
      code = String(code);
      return code === '0' ? (cfg.edgeNoneTitle || api.edgeLabels['0'] || 'No edging') : (EDGE_TITLE[code] || EDGE_TITLE['4']);
    }
    function edgeBit(code) { return api.edgeLabels ? ' \u00b7 <span class="clm-card__edge">' + esc(edgeLabel(code)) + '</span>' : ''; }
    // Which physical sides an option edges, in this panel's own sizes once they are known.
    function edgeMeaning(code, l, w) {
      var n = edgeCounts(code);
      if (!n.nL && !n.nW) return cfg.edgeNone || 'Raw board, cut only';
      if (n.nL === 2 && n.nW === 2) return 'All 4 sides';
      var sized = l > 0 && w > 0;
      if (!n.nW) return (n.nL === 2 ? 'Both ' : 'One ') + (sized ? l + 'mm' : 'length') + ' side' + (n.nL === 2 ? 's' : '');
      if (!n.nL) return (n.nW === 2 ? 'Both ' : 'One ') + (sized ? w + 'mm' : 'width') + ' side' + (n.nW === 2 ? 's' : '');
      return sized ? n.nL + ' \u00d7 ' + l + ' + ' + n.nW + ' \u00d7 ' + w + 'mm' : '3 sides';
    }
    // This panel line's edging at this option: metres from the sides, pence from the builder's own
    // edgeCost (the same length function and rate its total adds up). Null pence when it has none.
    function edgeCostOf(code, l, w, q) {
      if (!(l > 0) || !(w > 0)) return null;
      if (api.edgeCost) {
        var c = api.edgeCost(l, w, q, String(code));
        if (c && isFinite(c.metres)) return { metres: c.metres, pence: isFinite(c.pence) ? c.pence : null };
      }
      var n = edgeCounts(code);
      return { metres: (n.nL * l + n.nW * w) * Math.max(1, q || 1) / 1000, pence: null };
    }
    function edgeRate() {
      var c = api.edgeCost && api.edgeCost(1000, 1000, 1, '1');
      return c && isFinite(c.rate) && c.rate > 0 ? c.rate : 0;
    }
    // Single-option builders (one thickness) have no first step at all.
    function skipChoose() { return !!api.choices && colours().length < 2; }
    function colourLabel(c) { return [c.name, c.code].filter(Boolean).join(' · '); }
    function summary() {
      var total = 0, panels = 0, sheets = 0, lines = 0, anyErr = false, overCap = false, colours = 0, bad = 0, edgeM = 0;
      api.groups.forEach(function (g) {
        var t = g.totals || {};
        var list = panelsOf(g.id);
        lines += list.length;
        list.forEach(function (p) { if (p.err) bad++; });
        if (!g.colour.name && list.length) anyErr = true;
        if (bad) anyErr = true;
        if (g.overCap || t.overCap) overCap = true;
        if (t.hasPanels && !t.overCap) { total += t.totalCost; panels += t.panels; sheets += t.sheets; colours++; edgeM += Number(t.totalEdgeMetres || 0); }
      });
      var btn = document.getElementById('pb-addtocart');
      return {
        total: total, panels: panels, sheets: sheets, lines: lines, anyErr: anyErr, bad: bad, overCap: overCap, colours: colours, edgeM: edgeM,
        canAdd: !!btn && !btn.disabled, loading: !api.isMapLoaded(), btnText: btn ? btn.textContent.trim() : ''
      };
    }
    // Price breakdown (bd-price-breakdown.js) from the amounts the builder stored on each colour's
    // totals. Null when the builder supplies none, or when its rows don't add up to the bar's total.
    function breakdown(sm) {
      var B = window.BDPriceBreakdown;
      if (!B || !sm.total || sm.bad || sm.anyErr || sm.overCap) return null;
      var opt = api.vat && api.vat.rate ? {
        vatRate: Number(api.vat.rate) - 1,
        exLabel: 'Subtotal (' + (api.vat.exLabel || 'exc VAT') + ')',
        incLabel: 'Total (' + (api.vat.label || 'inc VAT') + ')'
      } : {};
      // Edging always has its row here, £0.00 when nothing is edged, so the choice shows in the sums.
      if (api.edgeLabels) { opt.edgeAlways = true; opt.edgeLabel = cfg.edgeStat || 'Edging'; }
      var m = B.build(api.groups.map(function (g) { return { name: g.colour.name, totals: g.totals, overCap: g.overCap }; }), opt);
      return m && m.net === sm.total ? m : null;
    }
    // The list as it stands, so the bar can tell when exactly this list is already in the basket.
    function orderKey() {
      return JSON.stringify(api.groups.map(function (g) {
        return [g.colour.name ? colourKey(g.colour) : '', panelsOf(g.id).map(function (p) {
          var row = [p.ownName, p.l, p.w, p.q, p.e];
          if (api.rowFields) api.rowFields.forEach(function (f) { row.push(p[f.key]); });
          return row;
        })];
      }));
    }
    function inBasket() { return !!S.basketKey && S.basketKey === orderKey() && pendingPanel() === 'none'; }
    // A panel still in the open form: 'none' (no form, or a new one left empty), 'ok' (ready to save) or 'bad'.
    function pendingPanel() {
      var form = S.edit && S.view === 'list' && root.querySelector('[data-clm-editor]');
      if (!form) return 'none';
      var e = readEditor(form);
      if (!e.id && !e.l && !e.w) return 'none';
      var tr = e.id && findRow(S.gid, e.id), d = tr && api.rowData(tr);
      // An existing panel opened but not changed is already in the list as it is.
      var nameEl = tr && tr.querySelector('.pb-name');
      var sameExtra = !d || !api.rowFields || api.rowFields.every(function (f) {
        return String(d[f.key] == null ? '' : d[f.key]) === String(e[f.key] == null ? '' : e[f.key]);
      });
      if (d && +d.l === e.l && +d.w === e.w && +d.q === e.q && (nameEl ? nameEl.value === e.name : true) &&
        (!api.edgeLabels || String(d.e) === String(e.e)) && sameExtra) return 'none';
      return e.l > 0 && e.w > 0 && !api.checkPanel(S.gid, e.l, e.w, e) ? 'ok' : 'bad';
    }

    // ---------- colours (read from the builder's own swatches) ----------
    var colourList = null;
    // A builder's "Popular" tab (kitchen worktops) repeats colours from its brand tabs: its keys in its
    // own order, and the label from its tab. Where it exists the colour step opens on it.
    var popularKeys = [];
    var popularLabel = '';
    function colours() {
      if (colourList) return colourList;
      if (api.choices) {
        colourList = api.choices().map(function (c) {
          var o = { name: c.name, code: c.code || '', manu: c.manu || '', handle: '', group: '', img: c.img || '', short: c.short || c.name, choiceKey: c.key };
          o.key = colourKey(o);
          return o;
        });
        return colourList;
      }
      var card = api.groups[0] && api.cardFor(api.groups[0].id);
      var seen = {};
      colourList = [];
      if (!card) return colourList;
      card.querySelectorAll('.pb-swatch:not(.pb-swatch--more)').forEach(function (b) {
        var c = {
          name: (b.getAttribute('data-colour-name') || '').trim(),
          code: (b.getAttribute('data-colour-code') || '').trim(),
          manu: titleCase((b.getAttribute('data-colour-manu') || '').trim()),
          handle: (b.getAttribute('data-colour-handle') || '').trim(),
          group: (b.getAttribute('data-colour-group') || '').trim(),
          img: (b.getAttribute('data-colour-img') || '').trim()
        };
        var k = colourKey(c);
        if (b.closest('[data-tab-panel="popular"]')) { if (c.name && popularKeys.indexOf(k) < 0) popularKeys.push(k); return; }
        if (!c.name || seen[k]) return;
        // A builder may sell only some brands (e.g. 16mm compact: Fundermax only).
        if (api.brands && api.brands.indexOf(brandKey(c.manu)) < 0) return;
        seen[k] = 1;
        c.key = k;
        colourList.push(c);
      });
      popularKeys = popularKeys.filter(function (k) { return seen[k]; });
      if (popularKeys.length) {
        var tab = card.querySelector('[data-pb-tab="popular"]');
        popularLabel = (tab && tab.textContent.trim()) || 'Popular';
        S.filter = 'popular';
      }
      return colourList;
    }
    function brandKey(m) { return String(m || '').trim().toLowerCase(); }
    // Swatches carry no reliable handle, so a colour is brand + code + name.
    function colourKey(c) { return [brandKey(c.manu), String(c.code || '').trim().toLowerCase(), String(c.name || '').trim().toLowerCase()].join('|'); }
    function selectColour(gid, c) {
      if (c && c.choiceKey != null && api.choose) { api.choose(gid, c.choiceKey); api.recompute(); return true; }
      var card = api.cardFor(gid);
      if (!card || !c) return false;
      var want = colourKey(c);
      var btn = Array.prototype.find.call(card.querySelectorAll('.pb-swatch:not(.pb-swatch--more)'), function (b) {
        return colourKey({ manu: b.getAttribute('data-colour-manu'), code: b.getAttribute('data-colour-code'), name: b.getAttribute('data-colour-name') }) === want;
      });
      if (!btn) return false;
      btn.click();
      api.recompute();
      return true;
    }
    function matchColourText(text) {
      var t = String(text || '').toLowerCase().replace(/\s+/g, ' ').trim();
      if (!t) return null;
      var list = colours();
      var byCode = list.filter(function (c) { return c.code && t.indexOf(c.code.toLowerCase()) >= 0; });
      if (byCode.length === 1) return byCode[0];
      if (byCode.length > 1) {
        var withBrand = byCode.filter(function (c) { return t.indexOf(c.manu.toLowerCase()) >= 0; });
        if (withBrand.length === 1) return withBrand[0];
      }
      var byName = list.filter(function (c) { return t.indexOf(c.name.toLowerCase()) >= 0; });
      return byName.length === 1 ? byName[0] : null;
    }
    // The colours the grid shows for the current brand filter and search.
    // "Popular" shows its colours in its own order; a search from there looks through every colour.
    function shownColours() {
      var q = S.q.trim().toLowerCase().replace(/\s+/g, '');
      var list = colours();
      if (S.filter === 'popular' && !q) {
        return popularKeys.map(function (k) { return list.find(function (c) { return c.key === k; }); });
      }
      return list.filter(function (c) {
        if (S.filter !== 'all' && S.filter !== 'popular' && brandKey(c.manu) !== S.filter) return false;
        if (!q) return true;
        return (c.name + c.code + c.manu + c.group).toLowerCase().replace(/\s+/g, '').indexOf(q) >= 0;
      });
    }
    // Clear the search, and the brand filter or "Show all" if needed, so the chosen colour is in the grid.
    function showCurrentInGrid() {
      var g = activeGroup();
      S.q = '';
      if (!g || !g.colour.name) return;
      var key = colourKey(g.colour);
      var mine = colours().find(function (c) { return c.key === key; });
      if (mine && shownColours().indexOf(mine) < 0) S.filter = 'all';
      var shown = shownColours();
      var i = shown.findIndex(function (c) { return c.key === key; });
      if (i >= CAP && shown.length > CAP + 2) S.showAll = true;
    }
    function chooseWord() { return String(cfg.chooseStep || 'Colour').toLowerCase(); }
    // The chosen colour after step 1 (panel list, review, the selected box): the whole chip is one
    // button that opens the colour step on this colour. With only one option it is plain text.
    function colourChip(g, from, prefix) {
      var c = g.colour;
      var meta = [c.code, c.manu, from === 'colour' ? '' : cfg.productLabel].filter(Boolean).join(' · ');
      var inner = (c.img ? '<img src="' + esc(c.img) + '" alt="" width="40" height="40">' : '<span class="clm-colourchip__ph"></span>') +
        '<span class="clm-colourchip__txt">' + (from === 'colour' ? '<span class="clm-colourchip__k">Selected</span>' : '') +
        '<strong>' + (prefix || '') + esc(c.name || 'No ' + chooseWord() + ' chosen') + '</strong>' + (meta ? '<span>' + esc(meta) + '</span>' : '') + '</span>';
      if (skipChoose()) return '<div class="clm-colourinfo">' + inner + '</div>';
      var label = c.name ? 'Change ' + chooseWord() + ': ' + c.name : 'Choose ' + chooseWord();
      return '<button type="button" class="clm-colourchip" data-act="' + (from === 'colour' ? 'findcolour' : 'changecolour') + '" data-g="' + g.id + '" data-from="' + from + '"' +
        ' aria-label="' + esc(label) + '">' + inner + '<span class="clm-colourchip__edit" aria-hidden="true">' + ICON_PEN + (c.name ? 'Change' : 'Choose') + '</span></button>';
    }

    // ---------- draft (per-device convenience; the builder rows stay the order) ----------
    function readDraft() {
      try {
        var d = JSON.parse(localStorage.getItem('bd-clm-draft-' + (api.product || 'panels')) || 'null');
        return d && d.groups && d.groups.some(function (g) { return g.rows && g.rows.length; }) ? d : null;
      } catch (e) { return null; }
    }
    var saveTimer = 0;
    function saveDraft() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        // S.ordered: the list just went to the basket, so don't offer it back until it is changed.
        if (!mq.matches || S.draft || S.ordered) return;
        var data = api.groups.map(function (g) {
          return {
            key: g.colour.name ? colourKey(g.colour) : '',
            rows: panelsOf(g.id).map(function (p) { return { name: p.ownName, l: p.l, w: p.w, q: p.q, e: p.e }; })
          };
        });
        try {
          if (data.some(function (g) { return g.rows.length; })) localStorage.setItem(STORE_KEY, JSON.stringify({ t: Date.now(), groups: data }));
          else localStorage.removeItem(STORE_KEY);
        } catch (e) { /* storage off: nothing to keep */ }
      }, 400);
    }
    function clearDraft() { try { localStorage.removeItem(STORE_KEY); } catch (e) {} S.draft = null; }
    function restoreDraft() {
      var d = S.draft;
      S.draft = null;
      if (!d) return;
      d.groups.forEach(function (gd, i) {
        var g = api.groups[i] || api.addGroup();
        if (gd.key) selectColour(g.id, colours().find(function (c) { return c.key === gd.key; }));
        api.setRows(g.id, gd.rows || []);
      });
      api.recompute();
      S.gid = api.groups[0].id;
      go(api.groups[0].colour.name ? 'list' : 'colour');
    }

    // ---------- navigation ----------
    function go(view, opts) {
      opts = opts || {};
      if (view !== 'list') S.edit = null;
      if (view !== 'colour') S.returnTo = null;
      S.view = view;
      if (!opts.fromHistory) {
        try { history.pushState({ clm: view, gid: S.gid }, ''); S.depth++; } catch (e) {}
      }
      render();
      if (!opts.noScroll) scrollToApp();
    }
    // A colour chip: the colour step for that list, its colour highlighted and in view.
    function openColour(gid, from) {
      if (gid && group(gid)) S.gid = gid;
      showCurrentInGrid();
      S.returnTo = from === 'review' ? 'review' : null;
      go('colour', { noScroll: true });
      revealCurrent(false);
    }
    // centre: the customer asked to see it (already on the colour step), so always scroll to it.
    function revealCurrent(centre) {
      var sw = root.querySelector('.clm-sw[aria-pressed="true"]');
      if (!centre) scrollToApp();
      if (!sw) return;
      var r = sw.getBoundingClientRect();
      var limit = (bar.hidden ? window.innerHeight : bar.getBoundingClientRect().top) - 8;
      if (centre || r.top < headerOffset() || r.bottom > limit) sw.scrollIntoView({ block: 'center' });
      sw.classList.add('is-current');
      try { sw.focus({ preventScroll: true }); } catch (e) {}
    }
    function backToReview() {
      S.returnTo = null;
      S.flashGid = S.gid;
      setTimeout(function () { S.flashGid = null; }, 1600);
      // The colour step was a step forward from the review: step back, so Back doesn't return here
      // and the browser puts the review back where the customer left it.
      if (S.depth > 0 && history.state && history.state.clm === 'colour') history.back();
      else go('review');
    }
    function back() {
      if (S.depth > 0) { history.back(); return; }
      var prev = S.view === 'list' ? 'colour' : 'list';
      go(prev, { fromHistory: true });
    }
    window.addEventListener('popstate', function (e) {
      if (!mq.matches) return;
      var st = e.state && e.state.clm ? e.state : { clm: 'list' };
      S.depth = Math.max(0, S.depth - 1);
      if (st.gid && group(st.gid)) S.gid = st.gid;
      go(st.clm, { fromHistory: true });
    });
    function headerOffset() {
      var h = document.querySelector('.shopify-section.section-bd-header, .bd-header, sticky-header, .section-header');
      var r = h ? h.getBoundingClientRect() : null;
      return r && r.bottom > 0 && getComputedStyle(h).position !== 'static' ? r.height : 0;
    }
    function scrollToApp() {
      var top = root.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 8;
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    }
    function toast(msg, undo) {
      S.toast = msg;
      S.undo = undo || null;
      clearTimeout(toastTimer);
      renderBar();
      toastTimer = setTimeout(function () { S.toast = ''; S.undo = null; renderBar(); }, undo ? 7000 : 2600);
    }

    // ---------- views ----------
    function progress(n, noBack) {
      var steps = [cfg.chooseStep || 'Colour', noun('Many'), 'Review'];
      // Tapping a step does what that step's own button does: Change, Continue, See the order summary.
      var acts = ['colour', 'tolist', 'toreview'];
      if (skipChoose()) { steps = steps.slice(1); acts = acts.slice(1); n = n - 1; if (n === 1) noBack = true; }
      return '<div class="clm-top">' +
        (noBack ? '<span></span>' : '<button type="button" class="clm-back" data-act="back"><span aria-hidden="true">‹</span> Back</button>') +
        '<span class="clm-stepno">Step ' + n + ' of ' + steps.length + '</span></div>' +
        '<ol class="clm-progress" aria-label="Progress">' + steps.map(function (s, i) {
          var done = i + 1 < n;
          var cls = done ? 'is-done' : i + 1 === n ? 'is-on' : '';
          var act = done ? acts[i] : i === n && stepOpen(acts[i]) ? acts[i] : '';
          return '<li class="' + cls + '"' + (i + 1 === n ? ' aria-current="step"' : '') + '>' +
            (act ? '<button type="button" class="clm-progress__go' + (done ? '' : ' clm-progress__go--next') + '" data-act="' + act + '">' + s +
              (done ? '<span class="clm-vh"> (done)</span>' : '<span aria-hidden="true"> ›</span>') + '</button>' : s) + '</li>';
        }).join('') + '</ol>';
    }
    // The step ahead opens only when its own button would work right now.
    function stepOpen(act) {
      var g = activeGroup();
      if (act === 'tolist') return !!(g && g.colour.name);
      var t = (g && g.totals) || {};
      return act === 'toreview' && S.view === 'list' && !!t.hasPanels && !t.overCap;
    }

    function draftBanner() {
      if (!S.draft || summary().lines) return '';
      var n = 0;
      S.draft.groups.forEach(function (g) { n += (g.rows || []).length; });
      return '<div class="clm-banner" role="status"><p><strong>Continue where you left off?</strong><br>' +
        plural(n, noun('one') + ' size') + ' in ' + plural(S.draft.groups.length, 'colour') + ', saved ' + ago(S.draft.t) + ' on this phone.</p>' +
        '<div class="clm-banner__acts"><button type="button" class="clm-btn clm-btn--primary" data-act="restore">Continue my list</button>' +
        '<button type="button" class="clm-btn clm-btn--text" data-act="discard">Start a new list</button></div></div>';
    }

    function quoteHtml(title) {
      return '<div class="clm-quote"><p>' + esc(title) + ' Send your list and we’ll reply with a quote.</p><div class="clm-quote__acts">' +
        (cfg.whatsapp ? '<a class="clm-btn clm-btn--small" href="' + esc(cfg.whatsapp) + '" target="_blank" rel="noopener noreferrer">WhatsApp</a>' : '') +
        (cfg.email ? '<a class="clm-btn clm-btn--small" href="' + esc(cfg.email) + '">Email</a>' : '') +
        (cfg.phone ? '<a class="clm-btn clm-btn--small" href="' + esc(cfg.phone) + '">Call ' + esc(cfg.phoneLabel || '') + '</a>' : '') +
        '</div></div>';
    }

    function viewColour() {
      var g = activeGroup();
      var idx = gIndex(g.id);
      var list = colours();
      var brands = [];
      list.forEach(function (c) { if (brands.indexOf(brandKey(c.manu)) < 0) brands.push(brandKey(c.manu)); });
      var q = S.q.trim().toLowerCase().replace(/\s+/g, '');
      var shown = shownColours();
      var cap = CAP;
      var trimmed = !q && !S.showAll && S.filter !== 'popular' && shown.length > cap + 2;
      var cur = g.colour;
      // The colour screen is where phones start: nothing to go back to until a colour or panel exists.
      var first = S.depth === 0 && (!cur.name || api.startOnChoice) && !summary().lines && api.groups.length < 2;
      var h = progress(1, first) +
        '<h2 class="clm-h">' + (api.groups.length > 1 ? 'Choose colour ' + (idx + 1) : esc(cfg.chooseTitle || 'Choose your colour')) + '</h2>' + draftBanner();
      if (cur.name) {
        h += '<div class="clm-picked clm-picked--chip">' + colourChip(g, 'colour') +
          (S.returnTo === 'review' ? '<button type="button" class="clm-btn clm-btn--primary clm-picked__go" data-act="return">Back to review →</button>'
            : '<button type="button" class="clm-btn clm-btn--primary clm-picked__go" data-act="tolist">Continue to ' + noun('many') + ' →</button>') + '</div>';
        if (api.isGrainLocked(cur.code)) h += grainNote();
      }
      h += (list.length <= 8 ? '' : '<div class="clm-search"><label class="clm-vh" for="clm-q">Search colours</label>' +
        '<input id="clm-q" type="search" data-clm-q placeholder="Search name or code, e.g. white, oak, W1000" value="' + esc(S.q) + '" autocomplete="off" enterkeyhint="search"></div>') +
        (brands.length < 2 && !popularKeys.length ? '<div hidden>' : '<div class="clm-chips" role="group" aria-label="' + (popularKeys.length ? 'Colours' : 'Laminate brand') + '">') +
        (popularKeys.length ? '<button type="button" class="clm-chip" data-act="filter" data-v="popular" aria-pressed="' + (S.filter === 'popular') + '">' + esc(popularLabel) + ' <span>' + popularKeys.length + '</span></button>' : '') +
        '<button type="button" class="clm-chip" data-act="filter" data-v="all" aria-pressed="' + (S.filter === 'all') + '">All <span>' + list.length + '</span></button>' +
        brands.map(function (b) {
          var n = list.filter(function (c) { return brandKey(c.manu) === b; }).length;
          return '<button type="button" class="clm-chip" data-act="filter" data-v="' + esc(b) + '" aria-pressed="' + (S.filter === b) + '">' + esc(b.charAt(0).toUpperCase() + b.slice(1)) + ' <span>' + n + '</span></button>';
        }).join('') + '</div>';
      if (!shown.length) {
        h += '<p class="clm-empty">No colours match “' + esc(S.q) + '”. Try a shorter word, or <button type="button" class="clm-link" data-act="clearq">show all colours</button>.</p>';
      } else {
        h += '<div class="clm-swatches">' + (trimmed ? shown.slice(0, cap) : shown).map(function (c) {
          var on = !!cur.name && colourKey(cur) === c.key;
          return '<button type="button" class="clm-sw' + (c.img ? '' : ' clm-sw--text') + '" data-act="pick" data-k="' + esc(c.key) + '" data-bw-priced="colour" aria-pressed="' + on + '">' +
            (c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy" width="240" height="240">' : '<span class="clm-sw__ph">' + esc(c.short || '') + '</span>') +
            '<span class="clm-sw__name">' + esc(c.name) + '</span>' +
            '<span class="clm-sw__meta">' + esc([c.code, c.manu].filter(Boolean).join(' · ')) + '</span>' +
            (api.isGrainLocked(c.code) ? '<span class="clm-sw__tag">Woodgrain</span>' : '') +
            '</button>';
        }).join('') + '</div>';
        if (trimmed) h += '<button type="button" class="clm-btn clm-btn--outline clm-btn--block" data-act="showall">Show all ' + shown.length + ' colours</button>';
      }
      h += '<p class="clm-sample">' + esc(cfg.sampleIntro || 'Not sure on colour?') + ' <button type="button" class="clm-link" data-act="sample">' + esc(cfg.sampleLabel || 'Order the sample chart') +
        (cfg.sampleMoney ? ' (' + esc(cfg.sampleMoney) + (api.vat ? ' ' + (api.vat.label || 'inc VAT') : ' exc VAT') + ')' : '') + '</button></p>';
      if (first && api.parseImportFile) {
        h += '<p class="clm-sample">Already have a cutting list? <label class="clm-link clm-file">Upload it (Excel or CSV)' +
          '<input type="file" data-clm-file accept=".csv,.txt,.tsv,.tab,.xls,.xlsx,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain"></label></p>';
      }
      return h;
    }

    function grainNote() {
      if (api.words) return '<p class="clm-grain"><span aria-hidden="true">↔</span> <span>Woodgrain runs along the <strong>length</strong> of the worktop.</span></p>';
      return '<p class="clm-grain"><span aria-hidden="true">↔</span> <span><strong>Woodgrain:</strong> the grain runs along the <strong>Length</strong> you enter, so put the grain direction in Length.</span></p>';
    }

    function groupTabs() {
      if (api.groups.length < 2) return '';
      return '<div class="clm-gtabs" role="tablist" aria-label="Colours in this order">' + api.groups.map(function (g, i) {
        var on = g.id === S.gid;
        var n = panelsOf(g.id).length;
        return '<button type="button" role="tab" class="clm-gtab" data-act="group" data-g="' + g.id + '" aria-selected="' + on + '">' +
          (g.colour.img ? '<img src="' + esc(g.colour.img) + '" alt="" width="24" height="24">' : '<span class="clm-gtab__ph"></span>') +
          '<span>' + (i + 1) + '. ' + esc(g.colour.name || 'No colour yet') + '<small>' + plural(n, noun('one') + ' size') + '</small></span></button>';
      }).join('') + '</div>';
    }

    function viewList() {
      var g = activeGroup();
      var idx = gIndex(g.id);
      var list = panelsOf(g.id);
      var t = g.totals || {};
      var h = progress(2) + '<h2 class="clm-h">Build your cutting list</h2>' + draftBanner() + groupTabs();
      if (S.report) h += reportHtml();
      h += pendingImportHtml();
      if (!g.colour.name) {
        h += '<div class="clm-needcolour"><p><strong>' + esc(cfg.chooseTitle || 'Choose a colour') + (api.groups.length > 1 ? ' for colour ' + (idx + 1) : '') + '</strong><br>' + noun('Many') + ' are checked against that board’s sheet size and priced once a colour is chosen.</p>' +
          '<button type="button" class="clm-btn clm-btn--primary" data-act="colour">Choose colour</button></div>';
      } else {
        var mp = api.maxPanel(g.id);
        h += colourChip(g, 'list') +
          '<p class="clm-sheetnote">Largest ' + noun('one') + ' on this board: ' + mp.l + ' × ' + mp.w + 'mm (length × ' + dimW.toLowerCase() + ').</p>';
        if (api.isGrainLocked(g.colour.code)) h += grainNote();
      }

      if (list.length) {
        h += '<div class="clm-cards">';
        list.forEach(function (p, i) {
          if (S.edit && S.edit.id === p.id) { h += editorHtml(); return; }
          var dims = (p.l || '—') + ' × ' + (p.w || '—') + ' mm';
          h += '<article class="clm-card' + (p.err ? ' is-invalid' : '') + '">' +
            '<button type="button" class="clm-card__main" data-act="edit" data-id="' + p.id + '" aria-label="Edit ' + esc(p.name) + ': ' + dims + ', quantity ' + p.q + (api.edgeLabels ? ', ' + esc(edgeLabel(p.e)) : '') + '">' +
            (api.figure ? api.figure(p.l, p.w, 'clm-card__fig') : panelFig(p.l, p.w, p.e, 'clm-card__fig')) +
            '<span class="clm-card__body"><span class="clm-card__dims">' + dims + ' ' + ICON_EDIT + '</span>' +
            '<span class="clm-card__meta"><span class="clm-card__name">' + esc(p.name) + '</span> · Qty ' + p.q + (api.rowSummary ? ' · ' + esc(api.rowSummary(p)) : edgeBit(p.e)) + '</span>' +
            (api.edgeSummary && p.l && p.w ? '<span class="clm-card__edges">' + esc(api.edgeSummary(p.l, p.w)) + '</span>' : '') +
            '</span></button>' +
            '<div class="clm-card__acts">' +
            '<button type="button" data-act="dup" data-id="' + p.id + '" aria-label="Duplicate ' + esc(p.name) + '">' + ICON_COPY + '<span>Duplicate</span></button>' +
            '<button type="button" data-act="del" data-id="' + p.id + '" aria-label="Delete ' + esc(p.name) + '">' + ICON_BIN + '<span>Delete</span></button>' +
            '</div>' +
            (p.err ? '<p class="clm-card__err">' + esc(p.err) + '</p>' : '') +
            (!p.err && p.warn ? '<p class="clm-card__warn">' + esc(p.warn) + '</p>' : '') +
            '</article>';
          void i;
        });
        h += '</div>';
      }
      if (S.edit && !S.edit.id) h += editorHtml();

      if (g.colour.name && !S.edit) {
        h += '<button type="button" class="clm-btn clm-btn--add clm-btn--block" data-act="add">+ Add ' + (list.length ? 'another ' + noun('one') : 'a ' + noun('one')) + '</button>';
      }
      if (t.hasPanels && !t.overCap) {
        // With a breakdown, this line opens it too (in the sticky bar), so tapping the sums explains them.
        var sub = '<span>' + (api.groups.length > 1 ? 'Colour ' + (idx + 1) + ': ' : '') + plural(t.panels, noun('one'), noun('many')) + ' · ' + plural(t.sheets, 'sheet') + '</span><strong>' + moneyShown(t.totalCost) + '</strong>';
        h += (breakdown(summary())
          ? '<button type="button" class="clm-subtotal clm-subtotal--btn" ' + window.BDPriceBreakdown.toggleAttrs('clm-pbk') + '>' + sub + window.BDPriceBreakdown.chevron + '<span class="clm-vh"> price breakdown</span></button>'
          : '<p class="clm-subtotal">' + sub + '</p>') +
          '<p class="clm-hint clm-subtotal__next">Order as many or as few ' + noun('many') + ' as you need: tap <strong>Add to basket</strong> below whenever your list is done.' +
          ' <button type="button" class="clm-link" data-act="toreview">See the order summary with VAT</button></p>';
      }
      h += '<div class="clm-more">' +
        (g.colour.name && !api.single ? '<button type="button" class="clm-btn clm-btn--outline clm-btn--block" data-act="addgroup">+ Add another colour</button>' : '') +
        (api.groups.length > 1 && idx > 0 ? '<button type="button" class="clm-link clm-link--danger" data-act="rmgroup">Remove colour ' + (idx + 1) + ' and its ' + noun('many') + '</button>' : '') +
        (api.parseImportFile ? '<label class="clm-btn clm-btn--outline clm-btn--block clm-file">Upload a cutting list<input type="file" data-clm-file accept=".csv,.txt,.tsv,.tab,.xls,.xlsx,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain"></label>' : '') +
        (api.parseImportFile ? '<p class="clm-hint">Excel or CSV with Length and ' + dimW + ' in mm (Qty, ' + (api.edgeLabels ? 'Edging and ' : '') + noun('One') + ' name optional). Every row is checked before you order.</p>' : '') +
        (api.exportCsv && summary().lines ? '<button type="button" class="clm-link" data-act="csv">Download my list as CSV</button>' : '') + '</div>' +
        quoteHtml('Rather we priced it for you?');
      return h;
    }

    function editorHtml() {
      var e = S.edit;
      var g = activeGroup();
      var title = e.dup ? 'Duplicate: change what’s different' : e.id ? 'Edit ' + esc(e.label) : noun('One') + ' ' + (panelsOf(g.id).length + 1);
      var grain = api.isGrainLocked(g.colour.code);
      return '<form class="clm-editor" data-clm-editor novalidate>' +
        '<p class="clm-editor__title">' + title + '</p>' +
        '<div class="clm-2col">' +
        '<label class="clm-field"><span>' + dimL + ' (mm)' + (grain ? ' <em>grain ↔</em>' : '') + '</span><input data-f="l" type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" enterkeyhint="next" placeholder="' + phL + '" value="' + (e.l || '') + '"></label>' +
        '<label class="clm-field"><span>' + dimW + ' (mm)</span><input data-f="w" type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" enterkeyhint="done" placeholder="' + phW + '" value="' + (e.w || '') + '"></label>' +
        '</div>' +
        '<p class="clm-err" data-clm-err role="alert"></p>' +
        (api.formFigure || api.drawFigure ? '<div class="clm-pf">' + (api.editorNote ? '<p class="clm-pf__note">' + esc(api.editorNote) + '</p>' : '') +
          '<div class="clm-pf__fig" data-clm-pffig></div>' +
          (api.openFigure ? '<button type="button" class="clm-link clm-pf__fs" data-act="pffs">View drawing full screen</button>' : '') + '</div>' : '') +
        // Quantity is typed (the box selects its number when tapped, so "12" replaces the 1); − and + step it.
        '<div class="clm-field"><label id="clm-qty-l" for="' + qtyId + '">Quantity</label><div class="clm-qty">' +
        '<button type="button" data-act="qty" data-d="-1" aria-label="One fewer">−</button>' +
        '<input id="' + qtyId + '" data-f="q" type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" enterkeyhint="done" aria-labelledby="clm-qty-l" value="' + e.q + '">' +
        '<button type="button" data-act="qty" data-d="1" aria-label="One more">+</button></div></div>' +
        (api.edgeLabels ? edgeFieldHtml(e) : '') +
        rowFieldsHtml(e) +
        (api.noName ? '' : '<label class="clm-field"><span>' + noun('One') + ' name <small>(optional)</small></span><input data-f="name" type="text" maxlength="80" autocomplete="off" enterkeyhint="done" placeholder="e.g. Shelf, Side, Door" value="' + esc(e.name) + '"></label>') +
        // Saving a panel is the secondary action: Add to basket on the bar is the one solid button.
        '<div class="clm-editor__acts"><button type="submit" class="clm-btn clm-btn--outline" data-clm-save data-bw-priced="dim">' + (e.id ? 'Save ' + noun('one') : 'Add ' + noun('one') + ' to list') + '</button>' +
        '<button type="button" class="clm-btn clm-btn--text" data-act="cancel">' + (e.id ? 'Cancel' : (panelsOf(g.id).length ? 'Done' : 'Cancel')) + '</button></div>' +
        '</form>';
    }

    // Edging: one choice, as radio cards. Each card draws the sides it edges, says which sides they
    // are and what they add to this panel line. paintEdges() fills in the parts that follow the sizes.
    function edgeFieldHtml(e) {
      var more = S.edgeMore || EDGE_MORE.indexOf(String(e.e)) >= 0;
      var card = function (code) {
        var on = String(e.e) === code;
        return '<button type="button" class="clm-ecard" role="radio" aria-checked="' + on + '" tabindex="' + (on ? '0' : '-1') + '" data-act="edgepick" data-v="' + code + '">' +
          edgeSvg(e.l, e.w, code, 'clm-ecard__fig') +
          '<span class="clm-ecard__t">' + esc(edgeLabel(code)) + '</span>' +
          '<span class="clm-ecard__d" data-k="d">' + esc(edgeMeaning(code, e.l, e.w)) + '</span>' +
          '<span class="clm-ecard__c" data-k="c"></span>' +
          '<span class="clm-ecard__tick" aria-hidden="true"><svg viewBox="0 0 16 16" focusable="false"><path d="M3.8 8.4l2.9 2.9 5.5-6.3"/></svg></span>' +
          '</button>';
      };
      return '<fieldset class="clm-edges"><legend id="clm-edges-l">' + esc(cfg.edgeTitle || 'Edging') + '</legend>' +
        '<p class="clm-edges__hint" data-clm-edgehint></p>' +
        '<div class="clm-ecards" role="radiogroup" aria-labelledby="clm-edges-l">' + EDGE_MAIN.map(card).join('') +
        '<div class="clm-ecards__more" id="clm-ecards-more"' + (more ? '' : ' hidden') + '>' + EDGE_MORE.map(card).join('') + '</div></div>' +
        '<button type="button" class="clm-link clm-edges__more" data-act="edgemore" aria-controls="clm-ecards-more" aria-expanded="' + more + '">' +
        (more ? 'Fewer edge combinations' : 'More edge combinations') + '</button>' +
        '<p class="clm-edgenote" data-clm-edgenote></p>' +
        '<p class="clm-edges__all" data-clm-edgeall hidden><button type="button" class="clm-link" data-act="edgeall"></button><span class="clm-edges__done"></span></p>' +
        '</fieldset>';
    }
    // Everything here is changed in place (text, attributes), never rebuilt, so a tap that lands as
    // a size field blurs still reaches the card under the finger.
    function paintEdges(form, e) {
      var set = function (el, txt) { if (el && el.textContent !== txt) el.textContent = txt; };
      var q = Math.max(1, e.q || 1);
      var sized = e.l > 0 && e.w > 0;
      var rate = edgeRate();
      var code = String(e.e);
      form.querySelectorAll('.clm-ecard').forEach(function (b) {
        var v = b.getAttribute('data-v');
        var on = v === code;
        if (b.getAttribute('aria-checked') !== String(on)) b.setAttribute('aria-checked', String(on));
        if (b.getAttribute('tabindex') !== (on ? '0' : '-1')) b.setAttribute('tabindex', on ? '0' : '-1');
        reshapeSvg(b.querySelector('svg'), e.l, e.w);
        set(b.querySelector('[data-k="d"]'), edgeMeaning(v, e.l, e.w));
        var c = edgeCostOf(v, e.l, e.w, q);
        var cost = v === '0' ? (api.edgeCost ? money(0) : '')
          : c ? (c.pence != null ? '+' + money(c.pence) + ' · ' : '') + metresText(c.metres)
          : rate ? money(rate) + ' a metre' : '';
        set(b.querySelector('[data-k="c"]'), cost);
      });
      // The selected option always shows: a choice among the extra combinations keeps them open.
      var moreBox = form.querySelector('#clm-ecards-more');
      var moreBtn = form.querySelector('[data-act="edgemore"]');
      var picked = EDGE_MORE.indexOf(code) >= 0;
      var open = S.edgeMore || picked;
      if (moreBox && moreBox.hidden === open) moreBox.hidden = !open;
      if (moreBtn) {
        if (moreBtn.hidden !== picked) moreBtn.hidden = picked;
        if (moreBtn.getAttribute('aria-expanded') !== String(open)) moreBtn.setAttribute('aria-expanded', String(open));
        set(moreBtn, open ? 'Fewer edge combinations' : 'More edge combinations');
      }
      var forWhat = q > 1 ? 'these ' + q + ' ' + noun('many') : 'this ' + noun('one');
      set(form.querySelector('[data-clm-edgehint]'), !api.edgeCost ? (sized ? 'Edge length for ' + forWhat + '.' : '')
        : sized ? 'Price for ' + forWhat + ', exc VAT.'
        : 'Prices exc VAT. Enter both sizes to price each option.');
      set(form.querySelector('[data-clm-edgenote]'), (code === '1' || code === '3' || code === '5' || code === '7')
        ? 'If it matters which side, say so in the ' + noun('one') + ' name.' : '');
      // Apply this choice to the rest of the list (more than one panel in it, counting this one).
      var all = form.querySelector('[data-clm-edgeall]');
      if (!all) return;
      var others = panelsOf(S.gid).filter(function (p) { return p.id !== e.id; });
      var n = others.length + 1;
      var same = others.every(function (p) { return String(p.e) === code; });
      if (all.hidden !== !others.length) all.hidden = !others.length;
      var btn = all.querySelector('button'), done = all.querySelector('.clm-edges__done');
      if (btn.hidden !== same) btn.hidden = same;
      set(btn, 'Apply to ' + (n === 2 ? 'both' : 'all ' + n) + ' ' + noun('many'));
      if (btn.getAttribute('aria-label') !== 'Apply ' + edgeLabel(code) + ' to ' + (n === 2 ? 'both' : 'all ' + n) + ' ' + noun('many')) {
        btn.setAttribute('aria-label', 'Apply ' + edgeLabel(code) + ' to ' + (n === 2 ? 'both' : 'all ' + n) + ' ' + noun('many'));
      }
      set(done, same ? '✓ ' + (n === 2 ? 'Both' : 'All ' + n) + ' ' + noun('many') + ': ' + edgeLabel(code) : '');
    }
    function pickEdge(code) {
      code = String(code);
      if (!S.edit || !root.querySelector('[data-clm-editor]') || String(S.edit.e) === code) return;
      S.edit.e = code;
      // An extra combination once chosen keeps that row open, so the cards never jump away.
      if (EDGE_MORE.indexOf(code) >= 0) S.edgeMore = true;
      paintEditor(false);
      renderBar();
    }
    // "Apply to all panels": the chosen edging on every other panel in this colour's list (and on this
    // one, if it is already in the list). Undo puts each panel's own edging back.
    function applyEdgeToAll() {
      var form = root.querySelector('[data-clm-editor]');
      if (!form || !S.edit) return;
      var e = readEditor(form);
      var code = String(e.e), gid = S.gid, prev = [];
      panelsOf(gid).forEach(function (p) {
        if (String(p.e) === code) return;
        prev.push({ id: p.id, e: String(p.e) });
        writeEdge(gid, p.id, code);
      });
      if (!prev.length) return;
      var n = panelsOf(gid).length + (e.id ? 0 : 1);
      S.ordered = false;
      api.recompute();
      render();
      var again = root.querySelector('.clm-ecard[aria-checked="true"]');
      if (again) again.focus();
      toast(edgeLabel(code) + ' now on ' + (n === 2 ? 'both' : 'all ' + n) + ' ' + noun('many'), {
        restore: function () {
          prev.forEach(function (x) { writeEdge(gid, x.id, x.e); });
          api.recompute();
        }
      });
    }
    // One panel's edging changed in its row, everything else written back as it is.
    function writeEdge(gid, id, code) {
      var tr = findRow(gid, id);
      if (!tr) return;
      var d = api.rowData(tr);
      var nameEl = tr.querySelector('.pb-name');
      var payload = { name: nameEl ? nameEl.value : '', l: d.l, w: d.w, q: d.q, e: code };
      if (api.rowFields) api.rowFields.forEach(function (f) { payload[f.key] = d[f.key]; });
      api.writeRow(tr, payload);
    }

    function viewReview() {
      var sm = summary();
      var h = progress(3) + '<h2 class="clm-h">Review &amp; order</h2>';
      api.groups.forEach(function (g, i) {
        var list = panelsOf(g.id);
        var t = g.totals || {};
        if (!list.length && !g.colour.name) return;
        h += '<section class="clm-rgroup' + (S.flashGid === g.id ? ' is-updated' : '') + '" data-g="' + g.id + '"><header class="clm-rgroup__head">' +
          colourChip(g, 'review', api.groups.length > 1 ? (i + 1) + '. ' : '') + '</header>';
        // Each row opens that panel in the editor (as the cards on the list do).
        h += '<ul class="clm-rlist">' + list.map(function (p) {
          return '<li class="' + (p.err ? 'is-invalid' : '') + '"><button type="button" class="clm-rlist__btn" data-act="editpanel" data-g="' + g.id + '" data-id="' + p.id + '"' +
            ' aria-label="Edit ' + esc(p.name) + ': ' + p.l + ' × ' + p.w + ' mm, quantity ' + p.q + (api.edgeLabels ? ', ' + esc(edgeLabel(p.e)) : '') + '">' +
            '<span class="clm-rlist__n">' + esc(p.name) + '</span>' +
            '<span class="clm-rlist__d">' + p.l + ' × ' + p.w + 'mm · ×' + p.q + ' ' + ICON_EDIT + '</span>' +
            (api.rowSummary ? '<span class="clm-rlist__e">' + esc(api.rowSummary(p)) + '</span>' : '') +
            (api.edgeLabels ? '<span class="clm-rlist__e clm-rlist__edge">' + panelFig(p.l, p.w, p.e, 'clm-rlist__fig') + esc(edgeLabel(p.e)) + '</span>' : '') +
            (api.edgeSummary ? '<span class="clm-rlist__e">' + esc(api.edgeSummary(p.l, p.w, true)) + '</span>' : '') +
            (p.err ? '<span class="clm-rlist__err">' + esc(p.err) + '</span>' : '') + '</button></li>';
        }).join('') + '</ul>' +
          '<button type="button" class="clm-btn clm-btn--small clm-rgroup__edit" data-act="editgroup" data-g="' + g.id + '">' + (list.length ? 'Edit ' : 'Add ') + noun('many') + '</button>';
        if (t.hasPanels && !t.overCap) {
          // Edging metres, and what they cost when the builder shows its sums (totals.parts).
          var edgeP = t.parts && isFinite(t.parts.edgePence) ? '<small class="clm-stats__sub">' + money(t.parts.edgePence) + '</small>' : '';
          h += '<dl class="clm-stats"><div><dt>' + noun('Many') + '</dt><dd>' + t.panels + '</dd></div><div><dt>Sheets</dt><dd>' + t.sheets + '</dd></div>' +
            (api.edgeLabels ? '<div><dt>' + esc(cfg.edgeStat || 'Edge banding') + '</dt><dd>' + metresText(t.totalEdgeMetres) + edgeP + '</dd></div>' : '') +
            '<div><dt>Price</dt><dd>' + (api.vat ? moneyShown(t.totalCost) : money(t.totalCost)) + '</dd></div></dl>';
        } else if (!g.colour.name) {
          h += '<p class="clm-card__err">Choose a colour for this list before ordering.</p>';
        }
        h += '</section>';
      });
      if (sm.overCap) {
        h += '<div class="clm-banner clm-banner--warn"><p><strong>This order is above the amount we can price online.</strong> Our sales team will quote it directly.</p>' +
          '<button type="button" class="clm-btn clm-btn--primary" data-act="overcap">Request a quote</button></div>';
      }
      h += '<div class="clm-totals"><dl>' +
        '<div><dt>' + noun('One') + ' lines</dt><dd>' + sm.lines + '</dd></div>' +
        '<div><dt>' + noun('Many') + ' in total</dt><dd>' + sm.panels + '</dd></div>' +
        '<div><dt>Sheets charged</dt><dd>' + sm.sheets + '</dd></div>' +
        '<div><dt>Delivery</dt><dd>Free UK delivery</dd></div>' +
        (api.vat
          ? '<div class="clm-totals__inc"><dt>Total ' + (api.vat.label || 'inc VAT') + '</dt><dd>' + (sm.total ? money(Math.round(sm.total * Number(api.vat.rate))) : '—') + '</dd></div>' +
            '<div><dt>Total ' + (api.vat.exLabel || 'exc VAT') + '</dt><dd>' + (sm.total ? money(sm.total) : '—') + '</dd></div>'
          : '<div class="clm-totals__big"><dt>Total exc VAT</dt><dd>' + (sm.total ? money(sm.total) : '—') + '</dd></div>' +
            '<div><dt>VAT (20%)</dt><dd>' + (sm.total ? money(sm.total * 0.2) : '—') + '</dd></div>' +
            '<div class="clm-totals__inc"><dt>Total inc VAT</dt><dd>' + (sm.total ? money(sm.total * 1.2) : '—') + '</dd></div>') +
        '</dl><p class="clm-hint">' + (api.single ? 'Your order is priced on the full sheets it needs.' : ('Each colour is priced on the full sheets its ' + noun('many') + ' need.')) + ' The price includes ' + esc(cfg.priceIncludes || 'the board, cutting, edge banding and delivery') +
        (cfg.leadTime ? ' (' + esc(cfg.leadTime) + ')' : '') + '.</p></div>';
      h += '<p class="clm-check"><strong>Before you order:</strong> check each finished size and its edging. ' + noun('Many') + ' are cut exactly as listed.</p>';
      h += (inBasket() && !S.busy ? '<button type="button" class="clm-btn clm-btn--outline clm-btn--lg clm-btn--block" data-act="viewbasket">In your basket ✓ View basket</button>'
        : '<button type="button" class="clm-btn clm-btn--primary clm-btn--lg clm-btn--block" data-act="basket"' + (sm.canAdd && !S.busy ? '' : ' aria-disabled="true"') + (S.busy ? ' aria-busy="true"' : '') + '>' +
        (S.busy ? 'Adding to basket…' : 'Add cutting list to basket') + '</button>') +
        '<p class="clm-status" data-clm-status role="status"></p>';
      h += quoteHtml('Prefer a quote first?');
      return h;
    }

    // ---------- import ----------
    function pendingImportHtml() {
      var p = S.pendingImport;
      if (!p) return '';
      var nCol = Object.keys(p.byGroup).length;
      return '<div class="clm-banner" role="dialog" aria-label="Import choice"><p><strong>' + plural(p.rows.length, noun('one'), noun('many')) + ' found in ' + esc(p.fileName) + '</strong>' +
        (nCol > 1 ? ' across ' + nCol + ' colours' : '') + '. You already have ' + plural(summary().lines, noun('one') + ' size') + ' in your list.</p>' +
        '<div class="clm-banner__acts"><button type="button" class="clm-btn clm-btn--primary" data-act="imp-replace">Replace my list</button>' +
        '<button type="button" class="clm-btn clm-btn--outline" data-act="imp-add">Add to my list</button>' +
        '<button type="button" class="clm-btn clm-btn--text" data-act="imp-cancel">Cancel</button></div></div>';
    }
    function reportHtml() {
      var r = S.report;
      var h = '<div class="clm-report ' + (r.issues.length ? 'is-warn' : 'is-ok') + '" role="status"><p><strong>' + esc(r.title) + '</strong></p>';
      if (r.issues.length) {
        h += '<p>Please check ' + (r.issues.length === 1 ? 'this row' : 'these rows') + ' from your file:</p><ul>' +
          r.issues.slice(0, 40).map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' +
          (r.issues.length > 40 ? '<p>and ' + (r.issues.length - 40) + ' more.</p>' : '');
      }
      return h + '<button type="button" class="clm-link" data-act="dismissreport">Hide this message</button></div>';
    }
    function onFile(input) {
      var file = input.files && input.files[0];
      input.value = '';
      if (!file) return;
      S.report = null;
      api.parseImportFile(file).then(function (res) {
        var rows = res.rows || [];
        var rejected = res.rejected || [];
        if (!rows.length) {
          S.report = {
            title: 'No ' + noun('many') + ' could be read from ' + file.name + '.',
            issues: rejected.length ? rejected.map(function (x) { return 'Row ' + x.line + ': ' + x.reason + '.'; })
              : ['Each row needs a Length and a Width in mm. A header row (Length, Width, Qty, Edging, Panel name) helps us read the columns.']
          };
          render();
          return;
        }
        var byGroup = {};
        rows.forEach(function (r) { var k = res.hasGroupColumn ? r.g : 1; (byGroup[k] = byGroup[k] || []).push(r); });
        var p = { fileName: file.name, rows: rows, rejected: rejected, byGroup: byGroup };
        if (summary().lines) { S.pendingImport = p; render(); return; }
        applyImport(p, 'replace');
      }).catch(function (err) {
        S.report = { title: 'We couldn’t read ' + file.name + '.', issues: [String(err && err.message || 'Try saving it as CSV and upload again.')] };
        render();
      });
    }
    function applyImport(p, mode) {
      S.pendingImport = null;
      S.ordered = false;
      var issues = [];
      var keys = Object.keys(p.byGroup).map(Number).sort(function (a, b) { return a - b; });
      var firstGid = null;
      if (mode === 'replace') {
        // Drop extra colours from the old list; colour 1 always stays.
        for (var i = api.groups.length - 1; i >= Math.max(1, keys.length); i--) api.removeGroup(api.groups[i].id);
      }
      keys.forEach(function (k, n) {
        var list = p.byGroup[k];
        var g;
        if (mode === 'replace') g = api.groups[n] || api.addGroup();
        else g = api.groups[k - 1] || api.addGroup();
        if (!firstGid) firstGid = g.id;
        var colourText = (list.find(function (r) { return r.colour; }) || {}).colour || '';
        if (colourText && (mode === 'replace' || !g.colour.name)) {
          var m = matchColourText(colourText);
          if (!m || !selectColour(g.id, m)) issues.push('Colour “' + colourText + '” wasn’t recognised. Please choose it.');
        }
        var existing = mode === 'add' ? panelsOf(g.id).map(function (x) { return { name: x.ownName, l: x.l, w: x.w, q: x.q, e: x.e }; }) : [];
        var incoming = list.map(function (r) { return { name: r.name, l: r.l, w: r.w, q: r.q, e: r.e }; });
        api.setRows(g.id, existing.concat(incoming));
        var trs = api.rowsFor(g.id).slice(existing.length);
        list.forEach(function (r, j) {
          var tr = trs[j];
          if (!tr) return;
          if (r.edgeUnknown) {
            tr.dataset.clmWarn = 'Edging “' + r.eRaw + '” from your file wasn’t recognised, so it’s set to All edges. Please check.';
            issues.push('Row ' + r.line + ': edging “' + r.eRaw + '” not recognised, set to All edges.');
          }
          var err = api.checkPanel(g.id, r.l, r.w);
          if (err) issues.push('Row ' + r.line + ': ' + err);
        });
      });
      p.rejected.forEach(function (x) { issues.push('Row ' + x.line + (x.name ? ' (' + x.name + ')' : '') + ': ' + x.reason + ', not imported.'); });
      var rowNo = function (t) { var m = /^Row (d+)/.exec(t); return m ? Number(m[1]) : 0; };
      issues.sort(function (a, b) { return rowNo(a) - rowNo(b); });
      api.recompute();
      var imported = p.rows.length;
      S.report = {
        title: 'Imported ' + plural(imported, 'panel') + (keys.length > 1 ? ' into ' + keys.length + ' colours' : '') + ' from ' + p.fileName + '.',
        issues: issues
      };
      S.gid = (api.groups.find(function (g) { return !g.colour.name; }) || group(firstGid) || api.groups[0]).id;
      go('list');
    }

    // ---------- editor ----------
    // afterId: the panel just added. The next form opens without focus, so the phone keyboard stays
    // down and the sticky Add to basket bar shows; that panel's card is scrolled into view.
    function openEditor(id, dup, afterId) {
      var g = activeGroup();
      if (id) {
        var tr = findRow(g.id, id);
        if (!tr) return;
        var d = api.rowData(tr);
        var nameInput = tr.querySelector('.pb-name');
        S.edit = { id: id, dup: !!dup, label: d.name, l: d.l, w: d.w, q: d.q, e: String(d.e), r: d.r, c: d.c, name: nameInput ? nameInput.value : '' };
      } else {
        var last = S.edit && !S.edit.id ? S.edit : null;
        S.edit = { id: null, l: 0, w: 0, q: 1, e: last ? String(last.e) : String(api.defaultEdge || '4'), name: '' };
      }
      if (EDGE_MORE.indexOf(S.edit.e) >= 0) S.edgeMore = true;
      S.view = 'list';
      render();
      setTimeout(repaintFig, 60);
      var form = root.querySelector('[data-clm-editor]');
      var added = afterId && root.querySelector('[data-act="edit"][data-id="' + afterId + '"]');
      if (form && added) {
        added.closest('.clm-card').scrollIntoView({ block: 'start' });
        window.scrollBy(0, -(headerOffset() + 8));
      } else if (form) {
        // First panel: keep the step header and colour in view; later panels: bring the form up.
        if (!panelsOf(g.id).length) scrollToApp();
        else {
          form.scrollIntoView({ block: 'start' });
          window.scrollBy(0, -(headerOffset() + 8));
        }
        var f = form.querySelector('[data-f="' + (dup ? 'w' : 'l') + '"]');
        if (f) { try { f.focus({ preventScroll: true }); if (dup) f.select(); } catch (e) { f.focus(); } }
      }
    }
    function readEditor(form) {
      var e = S.edit;
      e.l = int(form.querySelector('[data-f="l"]').value);
      e.w = int(form.querySelector('[data-f="w"]').value);
      e.q = Math.max(1, int(form.querySelector('[data-f="q"]').value) || 1);
      var nameEl = form.querySelector('[data-f="name"]');
      e.name = nameEl ? nameEl.value : (e.name || '');
      if (api.rowFields) {
        api.rowFields.forEach(function (f) {
          var sel = form.querySelector('[data-f="' + f.key + '"]');
          if (!sel) return;
          e[f.key] = sel.disabled ? (String(f.disabledWhen && f.disabledWhen[f.key]) || '') : sel.value;
          if (sel.disabled && f.disabledWhen) {
            Object.keys(f.disabledWhen).forEach(function (k) {
              if (String(f.disabledWhen[k]) === '0' && k !== f.key) e[f.key] = '';
            });
          }
        });
      }
      return e;
    }
    function paintEditor(showErr) {
      var form = root.querySelector('[data-clm-editor]');
      if (!form || !S.edit) return;
      var e = readEditor(form);
      var err = (e.l || e.w || showErr) ? api.checkPanel(S.gid, e.l, e.w, e) : '';
      syncRowFields(form, e);
      var partial = !showErr && (!e.l || !e.w);
      var errEl = form.querySelector('[data-clm-err]');
      // A size over the board's limit shows at once, even before the other size is typed.
      var show = !!err && (!partial || /can be up to/.test(err));
      errEl.textContent = show ? err : '';
      form.querySelector('[data-f="l"]').classList.toggle('is-bad', show && /length|least|fit/i.test(err));
      form.querySelector('[data-f="w"]').classList.toggle('is-bad', show && /width|depth|least|fit/i.test(err));
      if (!api.edgeLabels) {
        var pff = (api.formFigure || api.drawFigure) && form.querySelector('[data-clm-pffig]');
        // drawFigure draws into the element itself (live drawings); formFigure returns markup.
        if (pff) {
          if (api.drawFigure) api.drawFigure(pff, e, activeGroup().colour.img, S.gid);
          else setHtml(pff, api.formFigure(e.l, e.w, activeGroup().colour.img));
        }
        var okNoEdge = !err && e.l > 0 && e.w > 0;
        form.querySelector('[data-clm-save]').setAttribute('aria-disabled', okNoEdge ? 'false' : 'true');
        return okNoEdge;
      }
      paintEdges(form, e);
      var ok = !err && e.l > 0 && e.w > 0;
      form.querySelector('[data-clm-save]').setAttribute('aria-disabled', ok ? 'false' : 'true');
      return ok;
    }
    // quiet: the basket button is saving the open form on its way to the basket, so no next form.
    function saveEditor(form, quiet) {
      if (!paintEditor(true)) {
        var bad = form.querySelector('.is-bad, [data-f="l"]');
        if (bad && !int(form.querySelector('[data-f="l"]').value)) bad = form.querySelector('[data-f="l"]');
        else if (!int(form.querySelector('[data-f="w"]').value)) bad = form.querySelector('[data-f="w"]');
        if (bad && bad.focus) bad.focus();
        return false;
      }
      var e = S.edit;
      var g = activeGroup();
      S.ordered = false;
      var tr = e.id ? findRow(g.id, e.id) : null;
      if (!tr) tr = api.rowsFor(g.id).find(isBlank) || api.newRow(g.id);
      delete tr.dataset.clmWarn;
      var payload = { name: (e.name || '').trim(), l: e.l, w: e.w, q: e.q, e: e.e };
      if (api.rowFields) api.rowFields.forEach(function (f) { payload[f.key] = e[f.key]; });
      api.writeRow(tr, payload);
      api.recompute();
      if (quiet) { S.edit = null; return true; }
      if (e.id) {
        S.edit = null;
        render();
        var card = root.querySelector('[data-id="' + rowId(tr) + '"]');
        if (card) card.closest('.clm-card').scrollIntoView({ block: 'center' });
        toast(noun('One') + ' saved');
      } else {
        // Numbered, and says it isn't in the basket: customers took "Add panel" for an add to the basket.
        var num = panelsOf(g.id).findIndex(function (p) { return p.tr === tr; }) + 1;
        toast(noun('One') + ' ' + (num || panelsOf(g.id).length) + ' added to your list. It’s not in your basket yet');
        openEditor(null, false, rowId(tr));
      }
      return true;
    }

    // ---------- render ----------
    var bar = document.createElement('div');
    bar.className = 'clm-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Order total');
    pb.appendChild(bar);

    function render() {
      if (!mq.matches) return;
      var html = S.view === 'colour' ? viewColour() : S.view === 'review' ? viewReview() : viewList();
      html = '<div class="clm-view clm-view--' + S.view + '">' + html + '</div>';
      // An open panel form always redraws: its fields hold typed values the markup doesn't carry.
      if (S.edit) { root.innerHTML = html; root.__clmHtml = html; } else setHtml(root, html);
      pb.setAttribute('data-clm-view', S.view);
      if (S.edit && S.view === 'list') paintEditor(false);
      renderBar();
    }
    function renderBar() {
      if (!mq.matches) return;
      var sm = summary();
      var g = activeGroup();
      var left = '', btn = '', act = '', disabled = false;
      if (S.view === 'colour') {
        left = g && g.colour.name && !skipChoose()
          ? '<button type="button" class="clm-bar__colour" data-act="findcolour" aria-label="' + esc('Change ' + chooseWord() + ': ' + g.colour.name) + '">' +
            '<span class="clm-bar__k">Selected</span><span class="clm-bar__name">' + esc(g.colour.name) + ICON_PEN + '</span></button>'
          : g && g.colour.name ? '<span class="clm-bar__k">Selected</span>' + esc(g.colour.name) : '<span class="clm-bar__k">No colour selected</span>';
        if (S.returnTo === 'review') { btn = 'Back to review →'; act = 'return'; }
        else { btn = 'Continue to ' + noun('many') + ' →'; act = 'tolist'; }
        disabled = !(g && g.colour.name);
      } else if (S.view === 'list') {
        // Add to basket is on the bar from the first panel, so one panel (or any number) can be ordered
        // straight from the list; Review stays a link for the VAT summary.
        var pend = pendingPanel();
        var done = inBasket();
        var moneyBit = api.vat ? moneyShown(sm.total) : money(sm.total) + ' <small>exc VAT</small>';
        left = sm.bad ? '<span class="clm-bar__bad">' + plural(sm.bad, noun('one') + ' needs', noun('many') + ' need') + ' fixing</span><span class="clm-bar__k">Marked in red below</span>'
          : sm.anyErr ? '<span class="clm-bar__bad">Choose a colour for every list</span>'
          : sm.overCap ? 'Over online limit' : sm.total ? moneyBit + '<span class="clm-bar__k' + (done ? ' clm-bar__ok' : '') + '">' +
            (done ? 'In your basket ✓' : plural(sm.panels, noun('one'), noun('many')) + ' · ' + plural(sm.sheets, 'sheet') +
              (api.edgeLabels ? ' · ' + metresText(sm.edgeM) + ' ' + (cfg.edgeWord || 'edging') : '')) + '</span>'
          : sm.lines && sm.loading ? 'Pricing…' : pend === 'ok' ? '<span class="clm-bar__k">' + noun('One') + ' ready to add</span>' : '<span class="clm-bar__k">Add a ' + noun('one') + ' to see your price</span>';
        if (sm.overCap) { btn = 'Request a quote'; act = 'overcap'; }
        else if (done && !S.busy) { btn = 'View basket'; act = 'viewbasket'; }
        else { btn = S.busy ? 'Adding…' : 'Add to basket'; act = 'basket'; disabled = S.busy || sm.anyErr || (pend === 'none' && (!sm.lines || !sm.canAdd)); }
      } else {
        var inB = inBasket();
        var reviewMoney = api.vat ? moneyShown(sm.total) : money(sm.total) + ' <small>exc VAT</small>';
        var reviewNote = inB ? 'In your basket ✓' : (api.vat ? '' : money(sm.total * 1.2) + ' inc VAT');
        left = sm.total ? reviewMoney + (reviewNote ? '<span class="clm-bar__k' + (inB ? ' clm-bar__ok' : '') + '">' + reviewNote + '</span>' : '') : '—';
        if (sm.overCap) { btn = 'Request a quote'; act = 'overcap'; }
        else if (inB && !S.busy) { btn = 'View basket'; act = 'viewbasket'; }
        else { btn = S.busy ? 'Adding…' : 'Add to basket'; act = 'basket'; disabled = !sm.canAdd || S.busy; }
      }
      // With a breakdown, the total itself is the button that opens it (rows sit above the bar).
      var pbk = S.view === 'colour' ? null : breakdown(sm);
      var B = window.BDPriceBreakdown;
      var hadToggleFocus = !!document.activeElement && bar.contains(document.activeElement) && document.activeElement.hasAttribute('data-bd-pbk-toggle');
      bar.hidden = false;
      // The toast and the breakdown have their own slots, and each part is replaced only when it
      // changed, so the bar's buttons are never swapped mid-tap.
      if (!bar.__clmSlots) {
        bar.innerHTML = '<div data-clm-toastslot></div><div data-clm-pbkslot></div><div class="clm-bar__in"></div>';
        bar.__clmSlots = [bar.children[0], bar.children[1], bar.children[2]];
      }
      // A tap on the toast closes it rather than doing nothing.
      setHtml(bar.__clmSlots[0], S.toast ? '<div class="clm-toast" role="status" data-act="toastclose">' + esc(S.toast) + (S.undo ? ' <button type="button" data-act="undo">Undo</button>' : '') + '</div>' : '');
      setHtml(bar.__clmSlots[1], pbk ? B.panelHtml(pbk, 'clm-pbk') : '');
      // aria-disabled, not disabled: a greyed button still gets the tap, so it can say what's missing.
      setHtml(bar.__clmSlots[2],
        (pbk ? '<button type="button" class="clm-bar__sum" ' + B.toggleAttrs('clm-pbk') + '><span class="clm-bar__total">' + left + '</span>' + B.chevron + '<span class="clm-vh"> price breakdown</span></button>'
          : '<p class="clm-bar__total">' + left + '</p>') +
        '<button type="button" class="clm-btn clm-btn--primary" data-act="' + act + '"' + (disabled ? ' aria-disabled="true"' : '') + (S.busy ? ' aria-busy="true"' : '') + '>' + btn + '</button>');
      var pbkToggle = pbk && hadToggleFocus && bar.querySelector('[data-bd-pbk-toggle]');
      if (pbkToggle && document.activeElement !== pbkToggle) pbkToggle.focus();
    }

    // ---------- events ----------
    function onAct(el, ev) {
      var act = el.getAttribute('data-act');
      if (/^(dup|del|undo|rmgroup|imp-replace|imp-add|restore)$/.test(act)) S.ordered = false;
      var id = el.getAttribute('data-id');
      var g = activeGroup();
      switch (act) {
        case 'back': back(); break;
        case 'restore': restoreDraft(); break;
        case 'discard': clearDraft(); render(); break;
        case 'filter': S.filter = el.getAttribute('data-v'); S.showAll = false; render(); break;
        case 'clearq': S.q = ''; render(); break;
        case 'showall': S.showAll = true; render(); break;
        case 'sample': api.addSample(); break;
        case 'pick': {
          var c = colours().find(function (x) { return x.key === el.getAttribute('data-k'); });
          if (c && selectColour(g.id, c)) {
            // Choosing a colour moves straight on to the panels (first panel form open on an empty list),
            // or back to the review when the colour was changed from there.
            if (document.activeElement && root.contains(document.activeElement)) document.activeElement.blur();
            if (S.returnTo === 'review') { backToReview(); toast(titleCase(chooseWord()) + ' changed to ' + c.name); break; }
            go('list');
            if (!panelsOf(g.id).length) openEditor(null);
          }
          break;
        }
        case 'tolist':
          go('list');
          if (!panelsOf(g.id).length && g.colour.name) openEditor(null);
          break;
        case 'colour': go('colour'); break;
        case 'changecolour': openColour(el.getAttribute('data-g'), el.getAttribute('data-from')); break;
        case 'findcolour': showCurrentInGrid(); render(); revealCurrent(true); break;
        case 'return': backToReview(); break;
        case 'group': S.gid = el.getAttribute('data-g'); S.edit = null; render(); break;
        case 'editgroup': S.gid = el.getAttribute('data-g'); go('list'); break;
        case 'editpanel': S.gid = el.getAttribute('data-g'); go('list', { noScroll: true }); openEditor(id); break;
        case 'add': openEditor(null); break;
        case 'edit': openEditor(id); break;
        case 'dup': {
          var src = findRow(g.id, id);
          if (!src) break;
          var d = api.rowData(src);
          var nameEl = src.querySelector('.pb-name');
          var own = nameEl ? nameEl.value.trim() : '';
          var copy = api.newRow(g.id, src);
          var copyPayload = { name: own ? own + ' (copy)' : '', l: d.l, w: d.w, q: d.q, e: d.e };
          if (api.rowFields) api.rowFields.forEach(function (f) { copyPayload[f.key] = d[f.key]; });
          api.writeRow(copy, copyPayload);
          api.recompute();
          openEditor(rowId(copy), true);
          break;
        }
        case 'del': {
          var tr = findRow(g.id, id);
          if (!tr) break;
          var dd = api.rowData(tr);
          var nameEl = tr.querySelector('.pb-name');
          var keep = { gid: g.id, name: nameEl ? nameEl.value : '', l: dd.l, w: dd.w, q: dd.q, e: dd.e, prev: tr.previousElementSibling };
          if (api.rowFields) api.rowFields.forEach(function (f) { keep[f.key] = dd[f.key]; });
          api.removeRow(g.id, tr);
          api.recompute();
          render();
          toast(dd.name + ' deleted', keep);
          break;
        }
        case 'undo': {
          var u = S.undo;
          if (u && u.restore) { u.restore(); S.undo = null; S.toast = ''; render(); break; }
          if (!u || !group(u.gid)) break;
          var blank = api.rowsFor(u.gid).find(isBlank);
          var back2 = blank || api.newRow(u.gid, u.prev && u.prev.isConnected ? u.prev : null);
          if (!blank && !(u.prev && u.prev.isConnected)) {
            var first = api.rowsFor(u.gid)[0];
            if (first && first !== back2) first.before(back2);
          }
          api.writeRow(back2, u);
          api.recompute();
          S.undo = null; S.toast = '';
          render();
          break;
        }
        case 'cancel': S.edit = null; render(); break;
        case 'qty': {
          var qi = root.querySelector('[data-clm-editor] [data-f="q"]');
          qi.value = String(Math.max(1, (int(qi.value) || 1) + Number(el.getAttribute('data-d'))));
          paintEditor(false);
          break;
        }
        // A card picks its option; the one already picked stays picked (there is always a choice).
        case 'edgepick': pickEdge(el.getAttribute('data-v')); break;
        case 'edgemore': {
          S.edgeMore = el.getAttribute('aria-expanded') !== 'true';
          paintEditor(false);
          break;
        }
        case 'edgeall': applyEdgeToAll(); break;
        case 'pffs': if (api.openFigure && S.edit) api.openFigure(S.edit.l, S.edit.w, activeGroup().colour.img); break;
        case 'toastclose': clearTimeout(toastTimer); S.toast = ''; S.undo = null; renderBar(); break;
        case 'addgroup': {
          S.edit = null;
          var ng = api.addGroup();
          S.gid = ng.id;
          go('colour');
          break;
        }
        case 'rmgroup': {
          var n = panelsOf(g.id).length;
          if (n && !window.confirm('Remove colour ' + (gIndex(g.id) + 1) + ' and its ' + plural(n, 'panel') + '?')) break;
          var rmIdx = gIndex(g.id);
          api.removeGroup(g.id);
          S.gid = api.groups[Math.max(0, rmIdx - 1)].id;
          render();
          setTimeout(render, 260);
          break;
        }
        case 'csv': if (api.exportCsv()) toast('CSV downloaded'); break;
        case 'toreview': go('review'); break;
        case 'overcap': { var oc = pb.querySelector('[data-pb-overcap-reopen]'); if (oc) oc.click(); break; }
        case 'basket': addToBasket(); break;
        case 'viewbasket': viewBasket(); break;
        case 'imp-replace': applyImport(S.pendingImport, 'replace'); break;
        case 'imp-add': applyImport(S.pendingImport, 'add'); break;
        case 'imp-cancel': S.pendingImport = null; render(); break;
        case 'dismissreport': S.report = null; render(); break;
      }
      void ev;
    }
    function addToBasket() {
      if (S.busy) return;
      // From the list: a panel still in the form goes in first; a half-typed one is shown to fix.
      var form = S.view === 'list' && S.edit && root.querySelector('[data-clm-editor]');
      if (form) {
        var pend = pendingPanel();
        if (pend === 'bad') { saveEditor(form); toast('Finish this ' + noun('one') + ' first, or tap ' + (S.edit.id ? 'Cancel' : panelsOf(S.gid).length ? 'Done' : 'Cancel')); return; }
        if (pend === 'ok') saveEditor(form, true); else S.edit = null;
      }
      var sm = summary();
      if (!sm.canAdd || !sm.lines) {
        render();
        if (sm.lines && !sm.anyErr) toast(sm.loading ? 'Prices are still loading. Try again in a moment' : 'Check your list before adding it to the basket');
        return;
      }
      S.busy = true;
      render();
      // Through a promise, so a builder that throws still clears busy (and the "Adding…" button).
      Promise.resolve().then(function () { return api.addToCart(); }).then(function (msg) {
        S.busy = false;
        var ok = /added/i.test(msg) && !/could not|fail/i.test(msg);
        if (ok) { clearDraft(); S.ordered = true; S.basketKey = orderKey(); }
        render();
        var st = root.querySelector('[data-clm-status]');
        if (st) st.textContent = ok ? 'Added to your basket.' : (msg || 'Could not add to basket. Please try again.');
        if (!ok && S.view === 'list') toast(msg || 'Could not add to basket. Please try again.');
      }).catch(function () { S.busy = false; render(); });
    }
    function viewBasket() {
      if (window.BW && window.BW.openCartDrawer) window.BW.openCartDrawer();
      else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
    // The basket changed in the cart drawer (e.g. this list removed): offer Add to basket again.
    // The builders mount before the theme's deferred pubsub.js has run, so hook in once it has.
    function hookCartUpdates() {
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, function () { if (S.basketKey) { S.basketKey = null; render(); } });
        }
      } catch (e) { /* no pub/sub on this page */ }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hookCartUpdates);
    else hookCartUpdates();

    // A greyed-out button answers a tap with what is missing, instead of silently ignoring it.
    function explainDisabled(act) {
      if (S.busy) return; // the button already reads "Adding…"
      if (act === 'tolist') {
        toast('Choose a colour first');
        var grid = root.querySelector('.clm-swatches');
        var top = grid ? grid.getBoundingClientRect().top : 0;
        if (grid && (top < headerOffset() || top > window.innerHeight * 0.6)) {
          window.scrollTo({ top: Math.max(0, top + window.pageYOffset - headerOffset() - 8), behavior: 'auto' });
        }
        return;
      }
      var sm = summary();
      toast(sm.bad ? 'Fix the ' + noun(sm.bad === 1 ? 'one' : 'many') + ' marked in red first'
        : sm.anyErr ? 'Choose a colour for every list first'
        : sm.lines && sm.loading ? 'Prices are still loading. Try again in a moment'
        : !sm.lines ? 'Add a ' + noun('one') + ' first'
        : 'Check your list before adding it to the basket');
    }
    function handleClick(ev) {
      var el = ev.target.closest('[data-act]');
      if (!el || el.disabled) return;
      if (el.tagName === 'A') return;
      ev.preventDefault();
      if (el.getAttribute('aria-disabled') === 'true') { explainDisabled(el.getAttribute('data-act')); return; }
      onAct(el, ev);
    }
    // A tap that blurs a size field used to redraw the form inside that same tap, so the node under
    // the finger was replaced and no click fired. Work caused by a blur now waits until the tap is over.
    var pointerDown = false, afterTapQueue = [], afterTapTimer = 0;
    function afterTap(fn) {
      if (!pointerDown) { setTimeout(fn, 0); return; }
      afterTapQueue.push(fn);
      // A pointerup that never arrives (finger left the window) must not hold the redraw back.
      clearTimeout(afterTapTimer);
      afterTapTimer = setTimeout(tapOver, 800);
    }
    function tapOver() {
      clearTimeout(afterTapTimer);
      pointerDown = false;
      var q = afterTapQueue;
      afterTapQueue = [];
      if (q.length) setTimeout(function () { q.forEach(function (fn) { fn(); }); }, 0);
    }
    document.addEventListener('pointerdown', function () { pointerDown = true; }, true);
    document.addEventListener('pointerup', tapOver, true);
    document.addEventListener('pointercancel', tapOver, true);
    root.addEventListener('click', handleClick);
    bar.addEventListener('click', handleClick);
    root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t.matches('[data-clm-file]')) { onFile(t); return; }
      if (t.matches('[data-clm-editor] input')) {
        // A text field commits on blur, usually from a tap on another control: redraw after that tap.
        var form = t.closest('[data-clm-editor]');
        afterTap(function () { if (S.edit && form.isConnected) paintEditor(false); });
      }
      else if (t.closest('[data-clm-editor]')) paintEditor(false);
    });
    root.addEventListener('input', function (ev) {
      var t = ev.target;
      if (t.matches('[data-clm-q]')) {
        S.q = t.value;
        var pos = t.selectionStart;
        render();
        var again = root.querySelector('[data-clm-q]');
        if (again) { again.focus(); try { again.setSelectionRange(pos, pos); } catch (e) {} }
        return;
      }
      if (t.closest('[data-clm-editor]')) { paintEditor(false); renderBar(); }
    });
    root.addEventListener('focusout', function (ev) {
      if (ev.target.matches('[data-clm-editor] [data-f="l"], [data-clm-editor] [data-f="w"]')) {
        var form = ev.target.closest('[data-clm-editor]');
        afterTap(function () {
          // The tap may have saved, closed or replaced this form: only check the one that was left.
          if (!S.edit || !form.isConnected) return;
          // Once both sizes are in, show any problem on leaving the field (never clear a shown error here).
          var both = int(form.querySelector('[data-f="l"]').value) && int(form.querySelector('[data-f="w"]').value);
          if (both) paintEditor(true);
        });
      }
    });
    // A number box that already holds a number selects it when tapped into, so what is typed replaces
    // it: "12" in the quantity box gives 12, not 112. The tap's own mouseup/click would put the caret
    // where the finger landed, so select again after them.
    var NUM_FIELD = '[data-clm-editor] [data-f="q"], [data-clm-editor] [data-f="l"], [data-clm-editor] [data-f="w"]';
    var selectOnTap = null;
    function selectAll(t) {
      if (document.activeElement !== t || !t.value) return;
      try { t.setSelectionRange(0, t.value.length); } catch (e) {}
    }
    root.addEventListener('focusin', function (ev) {
      var t = ev.target;
      if (!t.matches(NUM_FIELD) || !t.value) return;
      selectOnTap = t;
      selectAll(t);
      setTimeout(function () { selectAll(t); }, 0);
      setTimeout(function () { if (selectOnTap === t) selectOnTap = null; }, 700);
    });
    root.addEventListener('mouseup', function (ev) { if (ev.target === selectOnTap) ev.preventDefault(); });
    root.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t !== selectOnTap) return;
      selectOnTap = null;
      selectAll(t);
      setTimeout(function () { selectAll(t); }, 0);
    });
    root.addEventListener('keydown', function (ev) {
      var t = ev.target;
      if (ev.key === 'Enter' && t.matches('[data-clm-editor] [data-f="l"]')) {
        ev.preventDefault();
        root.querySelector('[data-clm-editor] [data-f="w"]').focus();
      }
      // Radio group keys: arrows move to the next shown option and pick it, Home/End to the ends.
      if (t.matches('.clm-ecard') && /^(ArrowRight|ArrowDown|ArrowLeft|ArrowUp|Home|End)$/.test(ev.key)) {
        var cards = Array.prototype.slice.call(root.querySelectorAll('.clm-ecard')).filter(function (b) { return b.getClientRects().length; });
        var at = cards.indexOf(t);
        var to = ev.key === 'Home' ? 0 : ev.key === 'End' ? cards.length - 1
          : (at + (/Right|Down/.test(ev.key) ? 1 : -1) + cards.length) % cards.length;
        ev.preventDefault();
        pickEdge(cards[to].getAttribute('data-v'));
        cards[to].focus();
      }
    });
    root.addEventListener('submit', function (ev) {
      if (!ev.target.matches('[data-clm-editor]')) return;
      ev.preventDefault();
      saveEditor(ev.target);
    });

    // Redraw the to-scale edging diagram once the layout has settled, and when the width changes.
    function repaintFig() { if (S.edit && root.querySelector('[data-clm-editor]')) paintEditor(false); }
    window.addEventListener('resize', repaintFig, { passive: true });
    window.addEventListener('load', repaintFig);

    // Keep the bar out of the way of the phone keyboard, and bring it back as soon as the keyboard
    // closes (Android's back key closes it but leaves the field focused).
    function keyboardUp() {
      var vv = window.visualViewport;
      return !vv || window.innerHeight - vv.height * vv.scale > 120;
    }
    function syncKeyboard() {
      var a = document.activeElement;
      var typing = !!(a && root.contains(a) && a.matches('input:not([type="file"]), textarea')) && keyboardUp();
      pb.classList.toggle('clm-typing', typing);
    }
    // The field being typed in stays in sight: below the sticky header and above the keyboard. Checked
    // once the browser has done its own scroll (after focus, and when the keyboard has finished resizing).
    var inViewTimer = 0;
    function keepInView(delay) {
      clearTimeout(inViewTimer);
      inViewTimer = setTimeout(function () {
        var a = document.activeElement, vv = window.visualViewport;
        if (!vv || !mq.matches || !a || !root.contains(a) || !a.matches('input:not([type="file"]), textarea')) return;
        var r = a.getBoundingClientRect();
        var hdr = document.querySelector('.shopify-section.section-bd-header');
        var hb = hdr && getComputedStyle(hdr).position !== 'static' ? hdr.getBoundingClientRect().bottom : 0;
        var top = Math.max(vv.offsetTop, hb) + 8;
        var bottom = vv.offsetTop + vv.height - 8;
        if (r.height > bottom - top) return;
        if (r.top < top) window.scrollBy(0, r.top - top);
        else if (r.bottom > bottom) window.scrollBy(0, r.bottom - bottom);
      }, delay);
    }
    document.addEventListener('focusin', syncKeyboard);
    document.addEventListener('focusout', function () { setTimeout(syncKeyboard, 50); });
    root.addEventListener('focusin', function () { keepInView(350); });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { syncKeyboard(); keepInView(150); });

    pb.addEventListener('pb:updated', function () {
      if (!mq.matches) return;
      saveDraft();
      var a = document.activeElement;
      if (S.edit || (a && root.contains(a) && a.matches('input, select'))) { renderBar(); return; }
      render();
    });

    // ---------- Tablet and desktop: order bar ----------
    // From 768px the builder's own Step 3 button adds the list to the basket. Below 981px Step 3 sits
    // under the cut list and scrolls away as the list grows (and on wider screens its card can scroll
    // inside itself), so while that button is off screen this bar shows the running total and a button
    // that presses the builder's. The kitchen worktop designer has its own basket button.
    var obar = document.createElement('div');
    obar.className = 'pb-orderbar';
    obar.setAttribute('role', 'region');
    obar.setAttribute('aria-label', 'Your cut list');
    obar.hidden = true;
    obar.innerHTML = '<div class="pb-orderbar__in"><p class="pb-orderbar__sum"></p><button type="button" class="pb-orderbar__btn">Add to basket</button></div>';
    pb.appendChild(obar);
    var obarSum = obar.querySelector('.pb-orderbar__sum'), obarBtn = obar.querySelector('.pb-orderbar__btn');
    var layout = pb.querySelector('.pb-layout') || pb;
    // The site header covers the top of the screen: a button under it (e.g. the MDF sidebar pushed up
    // at the end of a long list) counts as off screen.
    function headerBottom() {
      var h = document.querySelector('.shopify-section.section-bd-header') || document.querySelector('.bd-header');
      var b = h ? h.getBoundingClientRect().bottom : 0;
      return b > 0 ? b : 0;
    }
    function orderBar() {
      var atc = document.getElementById('pb-addtocart');
      var show = !mq.matches && !!atc && !pb.querySelector('.ckw2');
      if (show) {
        var top = headerBottom(), vh = window.innerHeight, a = atc.getBoundingClientRect(), l = layout.getBoundingClientRect();
        var atcSeen = a.height > 0 && (Math.min(vh, a.bottom) - Math.max(top, a.top)) / a.height >= 0.6;
        show = !atcSeen && l.bottom > top && l.top < vh;
      }
      var sm = show ? summary() : null;
      show = show && sm.total > 0 && !sm.bad && !sm.anyErr && !sm.overCap;
      if (show) {
        var html = '<strong>' + plural(sm.panels, noun('one'), noun('many')) + '</strong> · ' + (api.vat ? moneyShown(sm.total) : money(sm.total) + ' <small>exc VAT</small>');
        if (obarSum.innerHTML !== html) obarSum.innerHTML = html;
        obarBtn.disabled = atc.disabled;
        obar.style.left = Math.max(0, l.left) + 'px';
        obar.style.width = Math.min(l.width, document.documentElement.clientWidth - Math.max(0, l.left)) + 'px';
      }
      obar.hidden = !show;
    }
    obarBtn.addEventListener('click', function () {
      var atc = document.getElementById('pb-addtocart');
      if (atc && !atc.disabled) atc.click();
    });
    var obarFrame = 0;
    function orderBarSoon() { if (!obarFrame) obarFrame = requestAnimationFrame(function () { obarFrame = 0; orderBar(); }); }
    pb.addEventListener('pb:updated', orderBarSoon);
    window.addEventListener('scroll', orderBarSoon, { passive: true });
    window.addEventListener('resize', orderBarSoon, { passive: true });

    // After "+ Add another panel" on tablet and desktop, say which panel was added and that the list
    // is not the basket. The note sits beside the button and fades.
    pb.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('.pb-add-row, #pb-add');
      if (!b || mq.matches || !b.parentElement) return;
      setTimeout(function () {
        var card = b.closest('.pb-step2-card, .pb-card--cutlist, .pb-card') || pb;
        var n = Array.prototype.filter.call(card.querySelectorAll('.pb-l'), function (x) { return x.offsetParent; }).length;
        var row = b.parentElement, note = row.querySelector('.pb-added');
        if (!note) { note = document.createElement('span'); note.className = 'pb-added'; note.setAttribute('role', 'status'); row.appendChild(note); }
        note.textContent = noun('One') + ' ' + n + ' added to your list (not in your basket yet)';
        note.classList.add('is-on');
        clearTimeout(note.__t);
        note.__t = setTimeout(function () { note.classList.remove('is-on'); }, 4000);
      }, 0);
    });

    // ---------- page chrome on phones ----------
    function setupFolds() {
      var specs = [
        [pb.querySelector('.pb-info__left .pb-infocard'), 'Common questions'],
        [pb.querySelector('.pb-info__right .pb-infocard'), 'About ' + (cfg.productLabel || 'this material')],
        [document.querySelector('.pdf-download-section'), 'Manufacturer colour charts']
      ];
      specs.forEach(function (sp) {
        var el = sp[0];
        if (!el || el.querySelector(':scope > .clm-foldbtn')) return;
        el.classList.add('clm-fold', 'is-folded');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'clm-foldbtn';
        b.setAttribute('aria-expanded', 'false');
        b.innerHTML = '<span>' + esc(sp[1]) + '</span><span aria-hidden="true" class="clm-foldbtn__i">+</span>';
        b.addEventListener('click', function () {
          var open = el.classList.toggle('is-folded') === false;
          b.setAttribute('aria-expanded', String(open));
        });
        el.insertBefore(b, el.firstChild);
      });
    }

    // Some builders (16mm compact) keep the FAQ and About cards inside the desktop layout, which
    // phones hide. On phones they sit just after it, as on the other cut lists; wider screens get
    // them back where they were.
    var infoHome = null;
    function placeInfo(on) {
      var layout = pb.querySelector('.pb-layout');
      var info = infoHome ? infoHome.__info : layout && layout.querySelector('.pb-info');
      if (!info) return;
      if (on && !infoHome) {
        infoHome = document.createComment('pb-info');
        infoHome.__info = info;
        info.parentNode.insertBefore(infoHome, info);
        layout.parentNode.insertBefore(info, layout.nextSibling);
      } else if (!on && infoHome) {
        infoHome.parentNode.insertBefore(info, infoHome);
        infoHome.remove();
        infoHome = null;
      }
    }

    function applyMode() {
      var on = mq.matches;
      pb.classList.toggle('pb--clm', on);
      bar.hidden = !on;
      orderBar();
      placeInfo(on);
      if (on) {
        setupFolds();
        if (!S.gid && api.groups[0]) S.gid = api.groups[0].id;
        render();
      }
    }
    if (mq.addEventListener) mq.addEventListener('change', applyMode); else if (mq.addListener) mq.addListener(applyMode);
    // Some browsers (and device emulation) skip the media-query change event on rotation.
    window.addEventListener('resize', function () { if (mq.matches !== pb.classList.contains('pb--clm')) applyMode(); }, { passive: true });
    // Phones start on the colour screen unless a list is already under way.
    if (api.groups[0] && !skipChoose() && (!api.groups[0].colour.name || api.startOnChoice) && !summary().lines) S.view = 'colour';
    // Already on the panels with nothing entered (e.g. a single-thickness board): show the first panel form, without focusing it.
    if (S.view === 'list' && api.groups[0] && api.groups[0].colour.name && !summary().lines && !S.draft) {
      S.edit = { id: null, l: 0, w: 0, q: 1, e: String(api.defaultEdge || '4'), name: '' };
    }
    try { history.replaceState(Object.assign({}, history.state || {}, { clm: S.view }), ''); } catch (e) {}
    applyMode();
  }

  // Adapter for the single-list builders (MDF family, lab panels): one list and an optional
  // choice (thickness or colour) instead of colour groups. The builder passes its own row,
  // pricing and basket functions and calls api.update(totals) after every recalculation.
  function simpleApi(o) {
    var last = null;
    var g = { id: 'g1', colour: { name: '', code: '', manu: '', img: '', handle: '' }, totals: null, _tbody: o.tbody };
    function sync() {
      var ch = o.current ? o.current() : null;
      g.colour = ch ? { name: ch.name || '', code: ch.code || '', manu: ch.manu || '', img: ch.img || '', handle: '' }
        : { name: o.choices ? '' : (o.label || 'Panels'), code: '', manu: '', img: '', handle: '' };
      var r = last;
      g.totals = r && r.panels > 0
        ? { hasPanels: true, panels: r.panels, sheets: r.sheets, totalCost: r.totalCost, totalEdgeMetres: r.edgeMetres || 0, overCap: !!r.overCap }
        : { hasPanels: false, panels: 0, sheets: 0, totalCost: 0, totalEdgeMetres: 0, overCap: false };
    }
    function rows() { return Array.prototype.slice.call(o.tbody.querySelectorAll('tr.pb-row')); }
    function fill(tr, d) {
      tr.querySelector('.pb-name').value = String(d.name || '');
      tr.querySelector('.pb-l').value = d.l ? String(d.l) : '';
      tr.querySelector('.pb-w').value = d.w ? String(d.w) : '';
      tr.querySelector('.pb-q').value = String(Math.max(1, d.q || 1));
      var e = tr.querySelector('.pb-e');
      if (e) e.value = String(d.e != null ? d.e : (o.defaultEdge || '4'));
      return tr;
    }
    var api = {
      product: o.product,
      groups: [g],
      single: true,
      edgeLabels: o.edgeLabels || null,
      edgeCost: o.edgeCost || null,
      defaultEdge: o.defaultEdge,
      startOnChoice: !!o.startOnChoice,
      choices: o.choices,
      choose: function (gid, key) { o.choose(key); sync(); },
      rowData: function (tr) { var d = o.rowData(tr); return { name: d.name, l: d.l, w: d.w, q: d.q, e: d.e == null ? '0' : String(d.e) }; },
      isMapLoaded: o.isMapLoaded || function () { return true; },
      isGrainLocked: function () { return false; },
      maxPanel: function () { return o.maxPanel(); },
      checkPanel: function (gid, l, w) { return o.checkPanel(l, w); },
      addGroup: function () { return g; },
      removeGroup: function () {},
      cardFor: function () { return null; },
      rowsFor: function () { return rows(); },
      writeRow: fill,
      newRow: function (gid, afterTr) {
        var tr = o.makeRow();
        if (afterTr && afterTr.parentElement === o.tbody) afterTr.after(tr); else o.tbody.appendChild(tr);
        o.bindRow(tr);
        return tr;
      },
      removeRow: function (gid, tr) {
        if (!tr) return;
        if (rows().length <= 1) fill(tr, { name: '', l: 0, w: 0, q: 1 }); else tr.remove();
      },
      setRows: function (gid, list) {
        o.tbody.innerHTML = '';
        (list.length ? list : [{ name: '', l: 0, w: 0, q: 1 }]).forEach(function (d) {
          var tr = fill(o.makeRow(), d);
          o.tbody.appendChild(tr);
          o.bindRow(tr);
        });
      },
      parseImportFile: function (file) {
        var io = window.PBCutlistIo;
        if (io && io.parseImportFileDetailed) return io.parseImportFileDetailed(file);
        return io.parseImportFile(file).then(function (list) { return { rows: list, hasGroupColumn: false, rejected: [] }; });
      },
      recompute: function () { o.recompute(); },
      addToCart: function () {
        return Promise.resolve(o.addToCart()).then(function () { return o.cartStatus ? String(o.cartStatus.textContent || '') : ''; });
      },
      addSample: function () { if (o.sampleBtn) o.sampleBtn.click(); },
      exportCsv: function () { return o.exportCsv ? o.exportCsv() : false; },
      update: function (r) { last = r; sync(); o.pb.dispatchEvent(new CustomEvent('pb:updated')); }
    };
    sync();
    return api;
  }

  window.BDCutlistMobile = { mount: mount, simpleApi: simpleApi };
})();
